import { createI18n } from 'vue-i18n'


const i18n = createI18n({
    legacy: false,
    locale: 'en', // set the default locale
    fallbackLocale: 'en', // set the fallback locale
    messages: {
        en: {
            headings:{
                generalCannabisGrowingCalculators:'General Cannabis Growing Calculators & Conversions',
                WeightConversion: 'Weight Conversion',
                DistanceConversion: 'Distance Conversion',
                TemperatureConversion: 'Temperature Conversion',
                SpeedConversion: 'Speed Conversion',
                AreaConversion: 'Area Conversion',
                VolumeConversion: 'Volume Conversion',
                FlowRateConversion: 'Flow rate Conversion',
                TimeConversion: 'Time Conversion',
                DateCalculator: 'Date Calculator',
                ECTDSConversion: 'EC/TDS Conversion',
                TrimmingTimePredictionCalculator: 'Trimming Time Prediction Calculator',
                PercentageCalculator: 'Percentage Calculator',
                CylinderDuctingVolume: 'Cylinder (Ducting) Volume',
                CannabisLightingPowerWaterCalculators: 'Cannabis Lighting/Power/Water Calculators',
                LightWattageLumens: 'Light Wattage/Lumens',
                DeliveredLumens: 'Delivered Lumens',
                BTUsGeneratedHeatOffsetCalculator: 'BTUs Generated/Heat Offset Calculator',
                CO2FlowRate: 'CO₂ Flow Rate',
                ExhaustCFMCalculator: 'Exhaust CFM Calculator',
                LightKWhCost: 'Light kWh & Cost',
                WaterUsageDripTipFlowCost: 'Water Usage/Drip Tip Flow & Cost',
                TimeLapseImageSize: 'Time Lapse Image Size',
                CannabisGrowingFertilizerAgricultureCalculators: 'Cannabis Growing/Fertilizer/Agriculture Calculators',
                DewPoint: 'Dew Point',
                VaporPressureDeficitCalculator: 'Vapor Pressure Deficit Calculator (VPD)',
                ProjectedGrowthTimelineCalendar: 'Projected Growth Timeline/Calendar',
                PlantLayout: 'Plant Layout',
                SoilAmountToTotal: 'Soil Amount to Total',
                SoilRatioToTotal: 'Soil Ratio to Total',
                PHWaterAdjustment: 'pH/Water Adjustment',
                NPKToPPMTDS: 'NPK to PPM TDS',
                PPMTDSToNPM: 'PPM TDS to NPM',
                DilutionToTDSTarget: 'Dilution to TDS Target',
                GeneralCropYield: 'General Crop Yield',
                DryWetYield: 'Dry/Wet Yield',
                EdibleCalculatorsConcentratesBlending: 'Edible Calculators, Concentrates, and Blending',
                EdiblePotency: 'Edible Potency',
                OilButterPotency: 'Oil/Butter Potency',
                THCPotencyConversions: 'THC/Potency Conversions',
                SaladsBlending: 'Salads & Blending',
                DecarboxylationLoss: 'Decarboxylation Loss',
                DecarboxylationCurvePrediction: 'Decarboxylation Curve Prediction',
                ExtractionEfficiency: 'Extraction Efficiency',
                SolventEvaporationTimeEstimate: 'Solvent Evaporation Time Estimate',
                ConcentrateToCapsuleTHCBreakdown: 'Concentrate to Capsule THC Breakdown',
                MaxPercentConstituentTerpeneAddition: 'Max Percent Constituent (Terpene Addition)'
                
            },
            Equations: 'Equations',
            minusSign: '-',
            plusSign: '+',
            whenSplit: 'when split',
            ways: 'ways',
            examplePerPlantOrPerRoom: 'e.g. per plant or per room',
            Area: 'Area',
            CylinderCalcDescription:' *When using cylinder volume to determine total ducting volume, use the totalducting length as the Height.',
            Radius: 'Radius',
            Height: 'Height',
            Volume: 'Volume',
            units3: 'Units³',
            StartDate: 'Start Date (YYYY-MM-DD)',
            StartTime: 'StartTime (HH:MM:SS)',
            Add: 'Add',
            Subtract: 'Subtract',
            Years: 'Years',
            Months: 'Months',
            Days: 'Days',
            Hours: 'Hours',
            Minutes: 'Minutes',
            Seconds: 'Seconds',
            AdjustedDate: 'Adjusted Date',
            AdjustedTime: 'Adjusted Time',
            InvalidInput: 'Invalid Input',
            dateCalcDesc: 'Add or subtract dates from a given start date',
            Distance: 'Distance',
            EC_TDS: 'EC/TDS',
            FlowRate: 'Flow Rate',
            Input: 'Input',
            Output: 'Output',

            determineIllumination: 'Determine necessary illumination for a given area.',
            desiredLumens: 'Desired Lumens*',
            desiredWatts: 'Desired Watts',
            growAreaWidth: 'Grow Area Width',
            growAreaLength: 'Grow Area Length',
            illuminationNeeded: 'Illumination Needed',
            wattsNeeded: 'Watts Needed',
            lumensWattsNote: '*Although lumens are a more precise measure of actual light output, watts have become a de facto standard -- when in doubt, use watts and disregard lumens.',
            lightingEquations:[
                'Illumination Needed = Grow Area Width * Grow Area Length * Desired Lumens',
                'Watts Needed = Grow Area Width * Grow Area Length * Desired Wattage',
            ],
            lumens: 'lumens',
            watts: 'watts',

            linearCalculatorExplanation: 'This calculator generalizes to any linear task (i.e., if it takes you one hour to do two, it will take two hours for four and three hours for six, etc.).',
            amountDone: 'Amount Done',
            timeTakenSoFar: 'Time Taken So Far',
            amountLeft: 'Amount Left',
            workPace: 'Work Pace',
            timeToCompletion: 'Time to Completion',
            units: 'Units',
            units_hr: 'Units/hr',
            linearCalcEquations:[
                'Work Pace = Amount Completed / Time Taken So Far',
                'Time to Completion = Amount Left / Work Pace'
            ],

            before: 'Before',
            after: 'After',
            change: 'Change',

            Speed: 'Speed',
            Temperature: 'Temperature',

            Time: 'Time',
            Weight: 'Weight',

            determineLumens: 'Determine the lumens per area delivered by given lights.',
            roomArea: 'Room Area',
            light1Lumens: 'Light 1 Lumens',
            light1Count: 'Light 1 Count',
            light2Lumens: 'Light 2 Lumens',
            light2Count: 'Light 2 Count',
            light3Lumens: 'Light 3 Lumens',
            light3Count: 'Light 3 Count',
            light4Lumens: 'Light 4 Lumens',
            light4Count: 'Light 4 Count',
            roomAreaOutput: 'Room Area',
            totalIllumination: 'Total Illumination',
            illuminationPerFtSq: 'Illumination per ft²',
            lights: 'lights',
            ftSq: 'ft²',
            lumensPerFtSq: 'lumens/ft²',
            DeliveredLightingEquations:[
                'Total Illumination = sum(Light X Count * Light X Lumens)',
                'Illumination per Area = Total Illumination / Area',

            ],


            ampCalcImportantNote: 'Important note:',
            wattageExplanation: 'the wattage referred to here is not the light output wattage (i.e., how bright the lights are). This is wattage in the true sense of power consumed by the lights. This information can usually be found in the datasheet for your lights. If no wattage is found, you can calculate it by multiplying the amperage the lights consume by the voltage (usually 120 in the US). For example, a light consuming 5 amps of power would consume 600 watts (5 amps * 120 volts).',
            monthAssumption: 'Month assumes 31 days.',
            singleLightWattage: 'Single Light Wattage',
            voltage: 'Voltage',
            dollarCostPerKWh: 'Dollar Cost per kWh',
            hoursOnPerDay: 'Hours On per Day',
            lightCount: 'Light Count',
            totalAmperage: 'Total Amperage',
            powerPerDay: 'Power per Day',
            costPerDay: 'Cost/Day',
            powerPerMonth: 'Power per Month',
            costPerMonth: 'Cost/Month',
            volts: 'volts',
            dollars: 'dollars',
            hours: 'hours',
            amps: 'amps',
            kWhPerDay: 'kWh/day',
            dollarSign: '$',
            kWhPerMonth: 'kWh/mo',
            ampCalcEquations:[
                'Total Amperage = Single Light Wattage / Voltage * Light Count',
                'Power per Day (kW) = Single Light Wattage * Hours on Per Day * Light Count / 1000',
                'Cost per Day = Power per Day * Dollar Cost per kWh',
                'Power per Month = Power per Day * 31',
                'Cost per Month = Power per Month * Dollar Cost per kWh',
            ],

            BtuImportantNote: 'Important note:',
            BtuWattageExplanation: 'the wattage referred to here is not the light output wattage (i.e. how bright the lights are). This is wattage in the true sense of power consumed by the lights. This information can usually be found in the datasheet for your lights. If no wattage is found, you can calculate it by multiplying the amperage the lights consume by the voltage (usually 120 in the US). For example, a light consuming 5 amps of power would consume 600 watts (5 amps * 120 volts).',
            btuCalculationAssumption: 'BTU calculations assume 3.412 BTUs/Watt',
            co2GeneratorBTUs: 'CO₂ Generator BTUs',
            co2Generators: 'CO₂ Generators',
            dehumidifierWattage: 'Dehumidifier Wattage',
            dehumidifiers: 'Dehumidifiers',
            btusPerHour: 'BTUs/Hr',
            btus: 'BTUs',
            generators: 'generators',
            BtcCalcEquations:[
                'BTUs per Watt = 3.4.12',
                'Total Light Wattage = Single Light Wattage * Light Count',
                'Total CO₂ BTUs = CO₂ Generator BTUs * CO₂ Generator Count',
                'Total Dehumidifier Wattage = Dehumidifier Wattage * Dehumidifier Count',
                'BTUs per Hour = (Total Light Wattage + Total Dehumidifier Wattage) * BTUs per Watt + Total CO₂ BTUs',
            ],

            
            determineCO2FlowRate: 'Determine CO₂ flow rate necessary for CO₂ supplementation to desired concentration.',
            co2SafetyNote: 'CO₂ is an asphyxiant and can kill. Always practice proper safety when utilizing CO₂ and CO₂ generating equipment.',
            roomWidth: 'Room Width',
            roomLength: 'Room Length',
            roomHeight: 'Room Height',
            volumeCompensation: 'Volume Compensation',
            ambientCO2: 'Ambient CO₂',
            desiredCO2: 'Desired CO₂',
            minutesOn: 'Minutes On',
            roomVolume: 'Room Volume',
            desiredAdditionalCO2: 'Desired Addtl. CO₂',
            fixedAdditionalCO2: 'Fixed Addtl. CO₂',
            co2FlowRatePerHour: 'CO₂ Flow Rate (per hour)',
            co2FlowRatePerMinute: 'CO₂ Flow Rate (per minute)',
            ppm: 'ppm',
            minutes: 'minutes',
            ftCubed: 'ft³',
            ftCubedPerHour: 'ft³/hr',
            scfh: 'SCFH (ft³/hr)',
            scfm: 'SCFM (ft³/min)',
            Co2RoomVolumeNote: '*Room volume does not account for space taken by ducting, fans, plant holders, etc. -- enter approximate volume consumed by objects in room here to increase volume accuracy. For ducting, use the Cylinder Volume calculator with length of ducting as cylinder height.',
            co2CalcEquations:[
                'Room Volume = Width * Length * Height - Volume Compensation',
                'Desired Addtl. CO₂ = Desired CO₂ - Ambient CO₂',
                'Fixed Addtl. CO₂ = (Desired Addtl. CO₂ * 1e-6) * Room Volume',
                'CO₂ Flow Rate = Fixed CO₂ Flow Rate / (Minutes On / 60)',
            ],

            airflowNote: 'Note that this is for pure airflow; this does not account for pressure lost due to bends in ducting, dust, etc. which is highly duct- and layout-specific.',
            fanCount: 'Fan Count',
            exchangeTime: 'Exchange Time',
            compensationFactorNote: 'Some sites recommend adding a compensation factor for high-heat or airflow-resistant sources such as HID lights and carbon filters. You can specify the correction and the number of such devices here, if desired; the room volume will be adjusted by the given percentage for each device. Common factors have been provided.',
            carbonFilterCount: 'Carbon Filter Count',
            carbonFilterCorrection: 'Carbon Filter Correction',
            oneKWHIDLightCount: '1kW HID Light Count',
            oneKWHIDLightCorrection: '1kW HID Light Correction',
            roomVolumeCorrected: 'Room Volume*',
            minTotalFlow: 'Min. Total Flow',
            minFanFlowEach: 'Min. Fan Flow Each',
            correctedForFiltersOrHIDLamps: '*Corrected for any given filters or HID lamps',
            fans: 'fans',
            minutesTotalAirFlush: 'minutes to total air flush',
            filters: 'filters',
            percent: '%',
            exhaustCalcEquations:[
                'Room Volume = (Width * Length * Height) + (Carbon Filter Count * Carbon Filter Correction) + (HID Light Count * HID Light Correction)',
                'Min. Total Flow = Room Volume / Exchange Time',
                'Min. Fan Flow Each = Min. Total Flow / Fan Count',
            ],


            imageFrequencyToSize: 'Image Frequency to Size',
            storageSpaceNote: 'Determine the storage space needed for a given image rate. Month assumes 31 days.',
            imageSize: 'Image Size',
            captureInterval: 'Capture Interval',
            sizePerDay: 'Size per Day',
            sizePerWeek: 'Size per Week',
            sizePerMonth: 'Size per Month',
            sizePerFourMonths: 'Size per 4 Months',
            mb: 'MB',


            captureIntervalFromSpaceRestriction: 'Capture Interval from Space Restriction',
            determineFastestCaptureInterval: 'Determine the fastest capture interval possible given a limited storage space.',
            storageSpace: 'Storage Space',
            totalLapseTime: 'Total Lapse Time',
            fastestInterval: 'Fastest Interval',
            gb: 'GB',
            days: 'days',

            weightConvCalcEquations:[
                'Water Used per Day = Water Rate per Plant * Hours on per Day * Plant Count',
                'Cost per Day = Water Used per Day * Water Cost',
                'Water Used per Month = Water Used per Day * 31',
                'Cost per Month = Water Used per Month * Water Cost',
            ],
            determineWaterUsageAndCost: 'Determine water usage and cost for a given number of plants and flow rate',
            equationWaterUsedPerDay: 'Water Used per Day = Water Rate per Plant * Hours on per Day * Plant Count',
            equationCostPerDay: 'Cost per Day = Water Used per Day * Water Cost',
            equationWaterUsedPerMonth: 'Water Used per Month = Water Used per Day * 31',
            equationCostPerMonth: 'Cost per Month = Water Used per Month * Water Cost',
            waterRatePerPlant: 'Water Rate per Plant',
            plantCount: 'Plant Count',
            waterCost: 'Water Cost',
            gph: 'gal/hr (GPH)',
            dollarsPerCubicFoot: 'dollars per ft³',
            waterUsedPerDay: 'Water Used/Day',
            waterUsedPerMonth: 'Water Used/Month*',
            gallonsPerDay: 'gal/day',
            gallonsPerMonth: 'gal/mo',


            determineDewPoint: 'Determine dew point.',
            temperature: 'Temperature',
            relativeHumidity: 'Rel. Humidity',
            dewPoint: 'Dew Point',
            dewPointEquations:[
                'Magnus formula:',
                'Dew Point Constants are a = 6.112 mb, b = 17.67, c = 243.5 °C (Bolton/Monthly Weather)',
                '[VaporPressureHelperValue = ln(RelHum. / 100) + ((b * Temp) / (c + Temp))]',
                'Dew/Frost Point = (c * VaporPressureHelperValue) / (b - VaporPressureHelperValue)',
            ],

            determinePlantCalendarDates: 'Determine calendar dates for important times in your plants\' lives',
            plantDate: 'Plant Date (YYYY-MM-DD)',
            daysToSprout: 'Days to Sprout',
            daysVegetative: 'Days Vegetative',
            daysFlowering: 'Days Flowering',
            daysDrying: 'Days Drying',
            daysCuring: 'Days Curing',
            daysProcessing: 'Days Processing',
            sprouted: 'Sprouted',
            floweringBegins: 'Flowering Begins',
            harvest: 'Harvest',
            doneDrying: 'Done Drying',
            doneCuring: 'Done Curing',
            doneProcessing: 'Done Processing',


            convertNPKtoPPMDesc: 'Convert from delivery-molecule-bound nitrogen, phosphorus, and potassium percentages ("NPK" values on fertilizer) to PPM TDS at a given dilution ratio.',
            fertilizerN: 'Fertilizer N',
            fertilizerP: 'Fertilizer P',
            fertilizerK: 'Fertilizer K',
            addedAmount: 'Added Amount',
            sgOverride: 'S.G. Override*',
            sgOverrideNote: '*In cases of a %w/v solution, enter the specific gravity of the fertilizer to correct for non-1.0 S.G. conversions.',
            npkMassPercentageNote: 'Mass percentage composition of elemental NPK in molecular NPK delivery substance; percentage given 0.00 - 1.00 inclusive. Presets assume elementals present as N, P₂O₅, and K₂O.',
            nMassFraction: 'N Mass Fraction',
            pMassFraction: 'P Mass Fraction',
            kMassFraction: 'K Mass Fraction',
            dilutedN: 'Diluted N',
            dilutedP: 'Diluted P',
            dilutedK: 'Diluted K',
            totalDiluted: 'Total Diluted',
            ppmTDS: 'PPM TDS',
            unitEmpty: '',
            mlPerLiter: 'ml fert./liter H₂O',
            NpkToTdsEquations:[
                '[Percent Mixture = Added Amount / 1000]',
                '[Final Percent = Percent Mixture * Fertilizer N]',
                '[Final PPM = Final Percent * 10000]',
                'Diluted Element = Final PPM * Mass Percent * S.G. Override',
            ],

            adjustPhDescription: 'Adjust pH of solution up or down with a known additive pH. Some common additive pHs:',
            startPh: 'Start pH',
            startVolume: 'Start Volume',
            desiredPh: 'Desired pH',
            additivePh: 'Additive pH',
            startMolarity: 'Start Mol.',
            additiveMolarity: 'Additive Mol.',
            desiredMolarity: 'Desired Mol.',
            additiveVolume: 'Additive Vol.',
            micromoles: 'µmol',
            phConvEquations:[
                'Start Mol. = 10e-[Start pH] / 1e-6',
                'Additive Mol. = 10e-[Additive pH] / 1e-6',
                'Desired Mol. = 10e-[Desired pH] / 1e-6',
                'Additive Vol. = ((Desired Mol. - Start Mol.) * Start Volume) / (Additive Mol. - Start Mol.)',
                '[Reformatted M₁V₁ + M₂V₂ = M₃V₃ = M₃(V₁ + V₂)]',
            ],

            plantCountCalculatorDescription: 'This calculator provides near-optimal layouts for rectangular plants.',
            growSpaceWidth: 'Grow Space Width',
            growSpaceLength: 'Grow Space Length',
            plantWidth: 'Plant Width*',
            plantLength: 'Plant Length*',
            gridLayout: 'Grid Layout',
            plantsWideBy: 'plants wide by',
            plantsLong: 'plants long',
            with: 'with',
            plantsInRemainingSpace: 'plants in remaining space',
            totalPlants: 'Total Plants',
            plants: 'plants',
            squareFeet: 'ft²',
            usedArea: 'Used Area',
            wastedSpace: 'Wasted Space',
            spaceEfficiency: 'Space Efficiency',
            plantCountSpacingNote: '*Remember to add the appropriate spacing between plants, which is counted as part of its size',


            determineSoilAmounts: 'Determine soil and soil amendment amounts, scaled up per-pot.',
            soil1Name: 'Soil 1 Name',
            soil1AmtPerPot: 'Soil 1 Amt./Pot',
            soil2Name: 'Soil 2 Name',
            soil2AmtPerPot: 'Soil 2 Amt./Pot',
            soil3Name: 'Soil 3 Name',
            soil3AmtPerPot: 'Soil 3 Amt./Pot',
            soil4Name: 'Soil 4 Name',
            soil4AmtPerPot: 'Soil 4 Amt./Pot',
            soil5Name: 'Soil 5 Name',
            soil5AmtPerPot: 'Soil 5 Amt./Pot',
            potCount: 'Pot Count',
            pots: 'pots',
            totalSoil: 'Total', // Dynamic label, will replace {medium} with the medium name
            SoilCalcEquations:[
                "Total = Amt. per Pot * Pot Count", 
            ],


            
            soilMixRatiosDescription: 'Given certain ratios of soil mix, scale up to provide total amounts for the number of pots.',
            potSize: 'Pot Size',

            computeDilutionDescription: 'Compute needed dilution to achieve target dissolved solids. For dilution with pure distilled water, use Additive TDS = 0.00.',
            currentTDS: 'Current TDS',
            currentVolume: 'Current Volume',
            targetTDS: 'Target TDS',
            additiveTDS: 'Additive TDS',

            tdsDilutionsEquations:[
                'Additive Volume = ((Target TDS - Current TDS) * Current Volume) / (Additive TDS - Target TDS)',
                '[Reformatted C₁V₁ + C₂V₂ = C₃V₃ = C₃(V₁ + V₂)]',
            ],


            convertElementalPPMtoNPK: 'Convert from nitrogen, phosphorus, and potassium as elemental PPM of a solution to delivery-molecule-bound mass percentages ("NPK" numbers on fertilizer).',
            fertilizerPPMN: 'Fert. PPM N',
            fertilizerPPMP: 'Fert. PPM P',
            fertilizerPPMK: 'Fert. PPM K',
            massPercentageCompositionNote: 'Mass percentage composition of elemental NPK in molecular NPK delivery substance; percentage given 0.00 - 1.00 inclusive. Presets assume elementals present as N, P₂O₅, and K₂O.',
            
            nitrogenPercentage: 'N',
            phosphorusPercentage: 'P',
            potassiumPercentage: 'K',
            tdsToNpkEquations:[
                'Element Percentage = (PPM / 10000) / Mass Percent',
            ],


            vaporPressureDeficitDescription: 'Vapor pressure deficit is the difference between the present and saturated moisture content of the air and affects plant transpiration. For most plants, a VPD of between 0.4kPa and 1.25kPa is ideal; ideal conditions for cannabis vary wildly depending on source but generally reside around 0.8kPa to 0.12kPa.',
            airTemperature: 'Air Temperature',
            leafTemperature: 'Leaf Temperature',
            airVPSat: 'Air VPSat',
            leafVPSat: 'Leaf VPSat',
            naiveVPD: 'Naive VPD',
            leafVPD: 'Leaf VPD',
            kPa: 'kPa',

            vaporPressureDeficitEquations:[
                'AirVPSat = 610.78 * e^(roomTempC / (roomTempC + 238.2) * 17.2694) / 1000',
                'LeafVPSat = 610.78 * e^(leafTempC / (leafTempC + 238.2) * 17.2694) / 1000',
                'Naive VPD = AirVPSat * (1 - relHumidity / 100)',
                'Leaf VPD = LeafVPSat - AirVPSat * relHumidity / 100',
                'Sourced from https://getpulse.co/blog/vpd',
            ],


            computeYieldsDescription: 'Compute min, avg., and max theoretical yields given a number of plants.',
            minYieldPerPlant: 'Min Yield/Plant',
            avgYieldPerPlant: 'Avg Yield/Plant',
            maxYieldPerPlant: 'Max Yield/Plant',
            minYield: 'Min Yield',
            avgYield: 'Avg Yield',
            maxYield: 'Max Yield',


            computeYieldsBasedOnHarvestWeights: 'Compute min, avg., and max theoretical yields given a number of plants based on harvest-time weights.',
            minWetYieldPerPlant: 'Min Wet Yield/Plant',
            avgWetYieldPerPlant: 'Avg Wet Yield/Plant',
            maxWetYieldPerPlant: 'Max Wet Yield/Plant',
            dryingLoss: 'Drying Loss*',
            dryingLossNote: '*This percentage is the amount of dry plant matter compared to wet -- e.g. 30 grams dry from 100 grams wet would mean a 70% Drying Loss. Use our Percentage Change calculator to input expected dry and wet values to arrive at this number.',

            capsuleCalcEquations:[
                "mL Cannabinoid in Extract = Test Percentage * Concentrate Volume",
                "Capsule Percentage of Total Mix = Container Volume / (Filler Volume + Concentrate Volume)",
                "Cannabinoid per Cap/Cart = mL Cannabinoid in Extract * Capsule Percentage of Total Mix",
                "",
                "Cap/Cart Cannabinoids = Sum of All Cannabinoids per Cap/Cart",
                "",
                "Caps/Carts Made = (Filler Volume + Concentrate Volume) / Container Volume",
            ],

            capsuleCannabinoidContentCalculation: 'Calculate capsule or cartridge cannabinoid content based on laboratory analysis.',
            concentrateVolume: 'Concentrate Vol.*',
            fillerVolume: 'Filler Vol.',
            containerVolume: 'Capsule/Cartridge Vol.',
            extractTestResults: 'Extract Test Results',
            THC: 'THC',
            THCa: 'THCa',
            delta8THC: 'Δ-8 THC',
            CBD: 'CBD',
            CBN: 'CBN',
            CBG: 'CBG',
            capCartTHC: 'Cap/Cart THC*',
            capCartTHCa: 'Cap/Cart THCa*',
            capCartDelta8THC: 'Cap/Cart Δ-8 THC*',
            capCartCBD: 'Cap/Cart CBD*',
            capCartCBN: 'Cap/Cart CBN*',
            capCartCBG: 'Cap/Cart CBG*',
            capCartTotalCannabinoids: 'Cap/Cart Cannabinoids*',
            capsCartsMade: 'Caps/Carts Made',
            CapsuleCalcApproximateConversionNote: '*1 mL ≈ 1 g for water, which can be used as an approximate conversion if exact volume is not known. If filling by weight, mL can be read as mg wherever the unit appears.',

            decarboxylationCalculationDescription: 'This determines the approximate amount of time to completely decarboxylate dry cannabis material based on data from scientific sources (more info in equation block). These numbers are an estimate, and may vary based on plant potency, density, and hydration. No data available for temperatures less than 100°C; results are unreliable below that point.',
            decarbTimeLabel: '~100% Decarb Time',

            decarbCurveEquations:[
                "Power best-fit curve determined from following sources' (identified by DOI and author) datapoints:",
                "10.1016/j.forsciint.2015.07.019 (Taschwer et. al.)",
                "   180min @ 100°C",
                "   60min @ 150°C",
                "10.1055/s-0031-1298334 (Eichler, et. al.)",
                "   12min @ 140°C",
                "   5min @ 210°C",
                "US7344736B2 (Patent)",
                "   240min @ 105°C",
                "   120min @ 120°C",
                "   60min @ 140°C",
                "",
                "Power best-fit: Time [minutes] = 4e+12 * (Temperature [°C])^-5.117",

            ],

            decarboxylationDescription: 'Calculate capsule or cartridge cannabinoid content based on laboratory analysis.',
            thcaLossTitle: 'THCa Loss Only',
            thcaLossDescription: 'When decarboxylating cannabis, the important reaction is the conversion of tetrahydrocannabinolic acid (THCa) to tetrahydrocannabinol (THC), the actual chemical that is psychoactive. Decarboxylation results in the loss of a carbon dioxide, causing a drop in molecular weight (358.4733 g/mol - 314.45 g/mol = 44.0233 g/mol loss (~12.22% loss)). This calculator allows you to determine the remaining THC after decarboxylation given pre-decarb THCa levels. Note that it does not take into account the molar weight loss due to CBDA to CBD, CBGA to CBG, etc. which are less typically accurately known for flower samples.',
            productTHCaContent: 'Product THCa Content',
            postDecarbTHCContent: 'Post-Decarb THC Content',
            productBasedLossTitle: 'Product-Based Loss',
            productAmount: 'Product Amount',
            productTHCaPercentage: 'Product THCa Percentage',
            preDecarbTHC: 'Pre-Decarb THC',
            postDecarbTHC: 'Post-Decarb THC',
            milligrams: 'mg',
            mgPerGram: 'mg/g',

            decarbLossEquations:[
                "Post-Decarb THC Content = Product THCa Content * (314.45 / 358.4733)" 
            ],


            mgPerServingTitle: 'mg/Serving',
            mgPerServingDescription: 'Determine serving potency given product/potency used assuming 100% THC extraction.',
            productPotency: 'Product Potency',
            servings: 'Servings',
            decarbCorrectionLabel: 'Correct for decarboxylation losses',
            mgTHCPerServing: 'mg THC/serving',
            percentTHC: '% THC',
            EdiblePotencyEquations:[
                "mg THC/serving = (Product Amount * Product Potency) / Servings"
            ],

            productAmountTitle: 'Product Amount',
            productAmountDescription: 'Determine needed product for given potency assuming 100% THC extraction.',
            productNeeded: 'Product Needed',
            edibleProductEquations:[
                "THC Needed = Servings * mg Per Serving",
                "Product Needed = THC Needed / Product Potency",
            ],

            servingCountTitle: 'Serving Count',
            servingCountDescription: 'Determine serving count given desired serving potency and product amount/potency assuming 100% THC extraction.',
            servingsOutput: 'Servings',
            edibleServingEquations:[
                "Servings = (Product Amount * Potency) / mg THC per Serving"
            ],


            solventEvaporationCalculatorDescription: 'To use this calculator, measure the weight of the solvent you are using before introducing it to the cannabis. After a time, weigh it again and note the new weight. Estimate the rough yield of product you expect as a correction factor (or measure the weight of the solvent before and after cannabis contact for a more precise value), and then this calculator will predict (assuming a linear evaporation rate) the rough amount of time it will take for the remaining solvent to evaporate. Please note that this is very imprecise and should only be used for vague estimates; true solvent evaporation is not always linear.',
            preCannabisSolventWeight: 'Pre-cannabis Solvent Weight',
            currentSolventWeight: 'Current Solvent Weight',
            timeSinceStart: 'Time Since Start',
            estimatedYield: 'Estimated Yield',
            evaporatedSolvent: 'Evapd. Solvent',
            solventLossPerHour: 'Solvent Loss/hr',
            timeToTotalEvaporation: 'Time to Total Evap',

            evapPredictionEquations:[
                "[Corrected Current Solvent Weight = Current Solvent Weight - Estimated Yield]",
                "Evaporated Solvent = Pre-cannabis Solvent Weight - Corrected Current Solvent Weight",
                "Solvent Loss per Hour = Evaporated Solvent / Time Since Start",
                "Time to Total Evaporation = Corrected Current Solvent Weight / Solvent Loss per Hour"
            ],

            extractionEfficiencyDescription: 'When making extracts, the efficiency of the process (how much extract is produced per unit of feedstock) is important, but far overshadowed by extraction efficiency -- how much of the THC present in the feedstock makes it into the extract. For example, a process may produce less extract but contain a higher concentration of THC than a different process since it pulls more THC and less waste (chlorophyll, etc.) from the plant. Extraction efficiency determines the percentage of THC extracted, producing a more reliable metric for evaluating extraction processes.',
            feedstockWeight: 'Feedstock Weight',
            feedstockTHCContent: 'Feedstock THC Content',
            extractWeight: 'Extract Weight',
            extractTHCContent: 'Extract THC Content',
            weightYield: 'Weight Yield',
            totalFeedstockTHC: 'Total Feedstock THC',
            totalExtractTHC: 'Total Extract THC',
            extractionEfficiency: 'Extraction Efficiency',
            extractionEfficiencyEquations:[
                "Weight Yield = Extract Weight / Feedstock Weight",
                "Total Feedstock THC = Feedstock THC Content * Feedstock Weight",
                "Total Extract THC = Extract THC Content * Extract Weight",
                "Extraction Efficiency = Total Extract THC / Total Feedstock THC",

            ],

            oilButterPotencyTitle: 'Oil/Butter Potency',
            oilButterPotencyDescription: 'Determine potency of an oil or butter prepared specifically for a recipe assuming 100% THC extraction.',
            oilButterInfused: 'Oil/Butter Infused',
            oilButterTotalTHC: 'Oil/Butter Total THC',
            oilButterTHCPerTablespoon: 'Oil/Butter THC/tbsp',
            oilButterTHCPerTeaspoon: 'Oil/Butter THC/tsp',
            mgPerTablespoon: 'mg/tbsp',
            mgPerTeaspoon: 'mg/tsp',

            oilButterPotencyEquations:[
                "Oil Total THC = Product Amount * Potency",
                "Oil THC per amt = Oil Total THC / Oil Infused",
            ],

            partialOilButterBlendTitle: 'Partial Oil/Butter Blend',
            partialOilButterBlendDescription: 'Determine the blend of medicated butter/oil with regular butter/oil for recipes with a known desired dosage, but where using solely medicated butter/oil would result in too potent of a dosage.',
            medicatedOilPotency: 'Medicated Oil Potency',
            recipeOilCalledFor: 'Recipe Oil Called For',
            desiredServings: 'Desired Servings',
            desiredPotency: 'Desired Potency',
            medicatedOilAmount: 'Medicated Oil Amount',
            regularOilAmount: 'Regular Oil Amount',
            mgTHCPerTablespoon: 'mg THC/tbsp',
            tablespoons: 'tbsp',
            mgPerServing: 'mg/serving',

            partialOilButterEquations:[
                "Medicated Oil Amount = Serving Count * Serving THC / Medicated Oil Potency",
                "Regular Oil = Total Oil Needed - Medicated Oil Amount",
            ],

            additiveAmountCalculationDescription: 'This solves for additive amount in cases where the additive can be, at a maximum, a given percentage of final constituency (e.g. many terpene additives recommend no more than 5% final constituency of the mixture; given 200g of concentrate, you can therefore add 10.526g of terpenes).',
            startAmount: 'Start Amount',
            finalPercentageOfAdditive: 'Final % of Additive',
            additiveAmountOutput: 'Additive Amt.',
            totalAmountOutput: 'Total Amt.',
            percentConstituentEquations:[
                "Total Amt. = Start Amount / (100 - Final % of Additive)",
                "Additive Amt. = Total Amt. - Start Amt."
            ],

            knownIngredientsTitle: 'Known Ingredients',
            knownIngredientsDescription: 'Determine the amount and potency of a final salad given known inputs.',
            product1: 'Product 1',
            product2: 'Product 2',
            product3: 'Product 3',
            product4: 'Product 4',
            thc: 'THC',
            cbd: 'CBD',
            finalProduct: 'Final Product',
            totalTHC: 'Total THC',
            totalCBD: 'Total CBD',
            thcToCbdRatio: 'Ratio: 1THC to',
            percentCBD: '% CBD',
            cbdUnit: 'CBD',

            saladGeneratorTitle: 'Salad Generator',
            saladGeneratorDescription: 'Determine the blend of options most closely approximating the desired ratio.',
            oneTHCTo: '1 THC to',
            maxElements: 'Max Elements',
            minimumTHC: 'Min. THC',
            productLabel: 'Product',
            thcPercentage: '% THC',
            cbdPercentage: '% CBD',
            grams: 'g',
            cantMakeBlend: "Can't make that blend!",

            thcPotencycalculatorSectionDescription: 'Choose the appropriate calculator section for your units. mg and g are used as standard analyte units; if your starting values are in a different unit, use our Weight Conversion calculator.',
            percentageTHC: 'Percentage THC',
            mgTHCPerGram: 'mg THC per Gram',
            mgTHCPerGramInput: 'mg THC/gram',
            percentageTHCOutput: 'Percentage THC',
            productVolume: 'Product Volume',
            productDensity: 'Product Density',
            mgMLTHC: 'mg/mL THC',
            mgGTHC: 'mg/g THC',
            thcPercentageOutput: 'THC Percentage',
            productWeight: 'Product Weight',
            mgTHCPerGramOutput: 'mg THC per Gram',
            milliliters: 'mL',
            gramsPerMilliliter: 'g/mL',

            variableServingPotencyTitle: 'Complete Recipe (Flowers, Volume)',
            variableServingPotencyDescription: 'Determine serving and potency breakdown of an oil or butter prepared specifically for a recipe assuming 100% THC extraction.',
            bakedGoodOilAmount: 'Baked Good Oil Amt.',
            bakedGoodServings: 'Baked Good Servings',
            bakedGoodTotalTHC: 'Baked Good Total THC',
            thcPerServing: 'THC/Serving',
            variableServingPotencyVolumeNote: '*This percentage is the amount of dry plant matter compared to wet -- e.g. 30 grams dry from 100 grams wet would mean a 70% Drying Loss. Use our Percentage Change calculator to input expected dry and wet values to arrive at this number.',
            variableServingPotencyVolumeEquations:[
                "Oil Total THC = Product Amount * Potency",
                "Oil THC per tbsp = Oil Total THC / Oil Infused",
                "Baked Good Total THC = Oil THC per tbsp * Baked Good Oil Amt. (in tbsp.)",
                "THC per Serving = Baked Good Total THC / Servings",
            ],

            completeRecipeOilButterVolumeTitle: 'Complete Recipe (Oil/Butter, Volume)',
            completeRecipeOilButterVolumeDescription: 'Determine serving and potency breakdown of an edible made with a known medicated oil/butter.',
            oilButterPotency: 'Oil/Butter Potency',
            mgPerCup: 'mg/cup',
            variableServPotenVolumeButteEquations:[
                "Baked Good Total THC = Oil THC per amount * Baked Good Oil Amt.",
                "THC per Serving = Baked Good Total THC / Servings",
            ],

            completeRecipeFlowersWeightTitle: 'Complete Recipe (Flowers, Weight)',
            completeRecipeFlowersWeightDescription: 'Determine serving and potency breakdown of an oil or butter prepared specifically for a recipe assuming 100% THC extraction.',
            
            oilButterInfusedWeight: 'Oil/Butter Infused',
            bakedGoodOilAmountWeight: 'Baked Good Oil Amt.',
            oilButterTHCPerGram: 'Oil/Butter THC/gram',
            variableServPotencyWeightEquations:[
                "Oil Total THC = Product Amount * Potency",
                "Oil THC per g = Oil Total THC / Oil Infused",
                "Baked Good Total THC = Oil THC per g * Baked Good Oil Amt. (in tbsp.)",
                "THC per Serving = Baked Good Total THC / Servings"
            ],
        }, 

        //portuguese

        pt: {

            headings: {
                generalCannabisGrowingCalculators: 'Calculadoras e Conversões Gerais para Cultivo de Cannabis',
                WeightConversion: 'Conversão de Peso',
                DistanceConversion: 'Conversão de Distância',
                TemperatureConversion: 'Conversão de Temperatura',
                SpeedConversion: 'Conversão de Velocidade',
                AreaConversion: 'Conversão de Área',
                VolumeConversion: 'Conversão de Volume',
                FlowRateConversion: 'Conversão de Taxa de Fluxo',
                TimeConversion: 'Conversão de Tempo',
                DateCalculator: 'Calculadora de Data',
                ECTDSConversion: 'Conversão EC/TDS',
                TrimmingTimePredictionCalculator: 'Calculadora de Previsão de Tempo de Poda',
                PercentageCalculator: 'Calculadora de Porcentagem',
                CylinderDuctingVolume: 'Volume de Cilindro (Dutos)',
                CannabisLightingPowerWaterCalculators: 'Calculadoras de Iluminação/Potência/Água para Cannabis',
                LightWattageLumens: 'Potência de Luz/Lúmens',
                DeliveredLumens: 'Lúmens Entregues',
                BTUsGeneratedHeatOffsetCalculator: 'Calculadora de BTUs Gerados/Compensação de Calor',
                CO2FlowRate: 'Taxa de Fluxo de CO₂',
                ExhaustCFMCalculator: 'Calculadora de CFM de Exaustão',
                LightKWhCost: 'Custo e kWh de Luz',
                WaterUsageDripTipFlowCost: 'Uso de Água/Custo de Fluxo de Gotejamento',
                TimeLapseImageSize: 'Tamanho de Imagem Time-Lapse',
                CannabisGrowingFertilizerAgricultureCalculators: 'Calculadoras para Cultivo de Cannabis/Adubo/Agricultura',
                DewPoint: 'Ponto de Orvalho',
                VaporPressureDeficitCalculator: 'Calculadora de Déficit de Pressão de Vapor (VPD)',
                ProjectedGrowthTimelineCalendar: 'Calendário/Cronograma de Crescimento Projetado',
                PlantLayout: 'Layout da Planta',
                SoilAmountToTotal: 'Quantidade de Solo para Total',
                SoilRatioToTotal: 'Proporção de Solo para Total',
                PHWaterAdjustment: 'Ajuste de pH/Água',
                NPKToPPMTDS: 'NPK para PPM TDS',
                PPMTDSToNPM: 'PPM TDS para NPM',
                DilutionToTDSTarget: 'Diluição para Alvo TDS',
                GeneralCropYield: 'Rendimento de Colheita Geral',
                DryWetYield: 'Rendimento Seco/Úmido',
                EdibleCalculatorsConcentratesBlending: 'Calculadoras para Comestíveis, Concentrados e Mistura',
                EdiblePotency: 'Potência de Comestíveis',
                OilButterPotency: 'Potência de Óleo/Manteiga',
                THCPotencyConversions: 'Conversões de Potência de THC',
                SaladsBlending: 'Saladas e Mistura',
                DecarboxylationLoss: 'Perda por Descarboxilação',
                DecarboxylationCurvePrediction: 'Previsão da Curva de Descarboxilação',
                ExtractionEfficiency: 'Eficiência de Extração',
                SolventEvaporationTimeEstimate: 'Estimativa de Tempo de Evaporação de Solvente',
                ConcentrateToCapsuleTHCBreakdown: 'Conversão de Concentrado para Cápsula - Detalhamento de THC',
                MaxPercentConstituentTerpeneAddition: 'Adição Máxima de Terpeno Constituinte (Porcentagem Máxima)'
            },
            Equations: 'Equações',
            minusSign: '-',
            plusSign: '+',
            whenSplit: 'quando dividido',
            ways: 'formas',
            examplePerPlantOrPerRoom: 'ex. por planta ou por sala',
            Area: 'Área',
            CylinderCalcDescription: '*Ao usar o volume do cilindro para determinar o volume total de dutos, use o comprimento total dos dutos como a Altura.',
            Radius: 'Raio',
            Height: 'Altura',
            Volume: 'Volume',
            units3: 'Unidades³',
            StartDate: 'Data de Início (AAAA-MM-DD)',
            StartTime: 'Hora de Início (HH:MM:SS)',
            Add: 'Adicionar',
            Subtract: 'Subtrair',
            Years: 'Anos',
            Months: 'Meses',
            Days: 'Dias',
            Hours: 'Horas',
            Minutes: 'Minutos',
            Seconds: 'Segundos',
            AdjustedDate: 'Data Ajustada',
            AdjustedTime: 'Hora Ajustada',
            InvalidInput: 'Entrada Inválida',
            dateCalcDesc: 'Adicionar ou subtrair datas de uma data de início dada',
            Distance: 'Distância',
            EC_TDS: 'EC/TDS',
            FlowRate: 'Taxa de Fluxo',
            Input: 'Entrada',
            Output: 'Saída',
            determineIllumination: 'Determinar a iluminação necessária para uma área dada.',
            desiredLumens: 'Lúmens Desejados*',
            desiredWatts: 'Watts Desejados',
            growAreaWidth: 'Largura da Área de Cultivo',
            growAreaLength: 'Comprimento da Área de Cultivo',
            illuminationNeeded: 'Iluminação Necessária',
            wattsNeeded: 'Watts Necessários',
            lumensWattsNote: '*Embora os lúmens sejam uma medida mais precisa da saída de luz real, os watts se tornaram um padrão de facto -- em caso de dúvida, use watts e ignore os lúmens.',
            lightingEquations: [
                'Iluminação Necessária = Largura da Área de Cultivo * Comprimento da Área de Cultivo * Lúmens Desejados',
                'Watts Necessários = Largura da Área de Cultivo * Comprimento da Área de Cultivo * Potência Desejada'
            ],
            lumens: 'lúmens',
            watts: 'watts',
            linearCalculatorExplanation: 'Esta calculadora generaliza para qualquer tarefa linear (ou seja, se leva uma hora para fazer dois, levará duas horas para quatro e três horas para seis, etc.).',
            amountDone: 'Quantidade Feita',
            timeTakenSoFar: 'Tempo Gasto Até Agora',

            amountLeft: 'Quantidade Restante',
            workPace: 'Ritmo de Trabalho',
            timeToCompletion: 'Tempo para Conclusão',
            units: 'Unidades',
            units_hr: 'Unidades/hora',
            linearCalcEquations: [
                'Ritmo de Trabalho = Quantidade Concluída / Tempo Gasto Até Agora',
                'Tempo para Conclusão = Quantidade Restante / Ritmo de Trabalho'
            ],

            before: 'Antes',
            after: 'Depois',
            change: 'Mudança',

            Speed: 'Velocidade',
            Temperature: 'Temperatura',

            Time: 'Tempo',
            Weight: 'Peso',

            determineLumens: 'Determine os lúmens por área fornecidos pelas luzes.',
            roomArea: 'Área da Sala',
            light1Lumens: 'Lúmens da Luz 1',
            light1Count: 'Quantidade da Luz 1',
            light2Lumens: 'Lúmens da Luz 2',
            light2Count: 'Quantidade da Luz 2',
            light3Lumens: 'Lúmens da Luz 3',
            light3Count: 'Quantidade da Luz 3',
            light4Lumens: 'Lúmens da Luz 4',
            light4Count: 'Quantidade da Luz 4',
            roomAreaOutput: 'Área da Sala',
            totalIllumination: 'Iluminação Total',
            illuminationPerFtSq: 'Iluminação por ft²',
            lights: 'luzes',
            ftSq: 'ft²',
            lumensPerFtSq: 'lúmens/ft²',
            DeliveredLightingEquations: [
                'Iluminação Total = soma(Quantidade da Luz X * Lúmens da Luz X)',
                'Iluminação por Área = Iluminação Total / Área'
            ],

            ampCalcImportantNote: 'Nota importante:',
            wattageExplanation: 'a potência referida aqui não é a potência de saída de luz (ou seja, quão brilhantes são as luzes). Esta é a potência no verdadeiro sentido de energia consumida pelas luzes. Essas informações geralmente podem ser encontradas na ficha técnica das suas luzes. Se não encontrar a potência, você pode calculá-la multiplicando a amperagem consumida pelas luzes pela tensão (geralmente 120 nos EUA). Por exemplo, uma luz que consome 5 amperes de energia consumiria 600 watts (5 amperes * 120 volts).',
            monthAssumption: 'Mês assume 31 dias.',
            singleLightWattage: 'Potência de Uma Única Luz',
            voltage: 'Voltagem',
            dollarCostPerKWh: 'Custo em Dólar por kWh',
            hoursOnPerDay: 'Horas Ligadas por Dia',
            lightCount: 'Quantidade de Luzes',
            totalAmperage: 'Amperagem Total',
            powerPerDay: 'Energia por Dia',
            costPerDay: 'Custo/Dia',
            powerPerMonth: 'Energia por Mês',
            costPerMonth: 'Custo/Mês',
            volts: 'volts',
            dollars: 'dólares',
            hours: 'horas',
            amps: 'amperes',
            kWhPerDay: 'kWh/dia',
            dollarSign: '$',
            kWhPerMonth: 'kWh/mês',
            ampCalcEquations: [
                'Amperagem Total = Potência de Uma Única Luz / Voltagem * Quantidade de Luzes',
                'Energia por Dia (kW) = Potência de Uma Única Luz * Horas Ligadas por Dia * Quantidade de Luzes / 1000',
                'Custo por Dia = Energia por Dia * Custo em Dólar por kWh',
                'Energia por Mês = Energia por Dia * 31',
                'Custo por Mês = Energia por Mês * Custo em Dólar por kWh'
            ],

            BtuImportantNote: 'Nota importante:',
            BtuWattageExplanation: 'a potência referida aqui não é a potência de saída de luz (ou seja, quão brilhantes são as luzes). Esta é a potência no verdadeiro sentido de energia consumida pelas luzes. Essas informações geralmente podem ser encontradas na ficha técnica das suas luzes. Se não encontrar a potência, você pode calculá-la multiplicando a amperagem consumida pelas luzes pela tensão (geralmente 120 nos EUA). Por exemplo, uma luz que consome 5 amperes de energia consumiria 600 watts (5 amperes * 120 volts).',
            btuCalculationAssumption: 'Cálculos de BTU assumem 3.412 BTUs/Watt',
            co2GeneratorBTUs: 'BTUs do Gerador de CO₂',
            co2Generators: 'Geradores de CO₂',
            dehumidifierWattage: 'Potência do Desumidificador',
            dehumidifiers: 'Desumidificadores',
            btusPerHour: 'BTUs/Hora',
            btus: 'BTUs',
            generators: 'geradores',
            BtcCalcEquations: [
                'BTUs por Watt = 3.4.12',
                'Potência Total de Luz = Potência de Uma Única Luz * Quantidade de Luzes',
                'Total de BTUs de CO₂ = BTUs do Gerador de CO₂ * Quantidade de Geradores de CO₂',
                'Potência Total de Desumidificador = Potência do Desumidificador * Quantidade de Desumidificadores',
                'BTUs por Hora = (Potência Total de Luz + Potência Total de Desumidificador) * BTUs por Watt + Total de BTUs de CO₂'
            ],

            determineCO2FlowRate: 'Determine a taxa de fluxo de CO₂ necessária para a suplementação de CO₂ à concentração desejada.',
            co2SafetyNote: 'O CO₂ é um asfixiante e pode matar. Sempre pratique segurança adequada ao utilizar equipamentos de CO₂ e geradores de CO₂.',
            roomWidth: 'Largura da Sala',
            roomLength: 'Comprimento da Sala',
            roomHeight: 'Altura da Sala',
            volumeCompensation: 'Compensação de Volume',
            ambientCO2: 'CO₂ Ambiente',
            desiredCO2: 'CO₂ Desejado',
            minutesOn: 'Minutos Ligado',
            roomVolume: 'Volume da Sala',
            desiredAdditionalCO2: 'CO₂ Adicional Desejado',
            fixedAdditionalCO2: 'CO₂ Adicional Fixo',
            co2FlowRatePerHour: 'Taxa de Fluxo de CO₂ (por hora)',
            co2FlowRatePerMinute: 'Taxa de Fluxo de CO₂ (por minuto)',
            ppm: 'ppm',
            minutes: 'minutos',
            ftCubed: 'ft³',
            ftCubedPerHour: 'ft³/hora',
            scfh: 'SCFH (ft³/hora)',
            scfm: 'SCFM (ft³/minuto)',
            Co2RoomVolumeNote: '*O volume da sala não considera o espaço ocupado por dutos, ventiladores, suportes de plantas, etc. -- insira aqui o volume aproximado consumido por objetos na sala para aumentar a precisão do volume. Para dutos, use a calculadora de Volume de Cilindro com o comprimento dos dutos como altura do cilindro.',
            co2CalcEquations: [
                'Volume da Sala = Largura * Comprimento * Altura - Compensação de Volume',
                'CO₂ Adicional Desejado = CO₂ Desejado - CO₂ Ambiente',
                'CO₂ Adicional Fixo = (CO₂ Adicional Desejado * 1e-6) * Volume da Sala',
                'Taxa de Fluxo de CO₂ = CO₂ Adicional Fixo / (Minutos Ligado / 60)',
            ],

            airflowNote: 'Note que isso é para fluxo de ar puro; isso não leva em conta a perda de pressão devido a curvas nos dutos, poeira, etc., que é altamente específico para o duto e layout.',
            fanCount: 'Quantidade de Ventiladores',
            exchangeTime: 'Tempo de Troca',
            compensationFactorNote: 'Alguns sites recomendam adicionar um fator de compensação para fontes de calor intenso ou resistentes ao fluxo de ar, como luzes HID e filtros de carbono. Você pode especificar a correção e o número de tais dispositivos aqui, se desejar; o volume da sala será ajustado pelo percentual dado para cada dispositivo. Fatores comuns foram fornecidos.',
            carbonFilterCount: 'Quantidade de Filtros de Carbono',
            carbonFilterCorrection: 'Correção de Filtro de Carbono',
            oneKWHIDLightCount: 'Quantidade de Luzes HID de 1kW',
            oneKWHIDLightCorrection: 'Correção de Luz HID de 1kW',
            roomVolumeCorrected: 'Volume da Sala*',
            minTotalFlow: 'Fluxo Total Mínimo',
            minFanFlowEach: 'Fluxo Mínimo por Ventilador',
            correctedForFiltersOrHIDLamps: '*Corrigido para quaisquer filtros ou lâmpadas HID dados',
            fans: 'ventiladores',
            minutesTotalAirFlush: 'minutos para a completa troca de ar',
            filters: 'filtros',
            percent: '%',
            exhaustCalcEquations: [
                'Volume da Sala = (Largura * Comprimento * Altura) + (Quantidade de Filtros de Carbono * Correção de Filtro de Carbono) + (Quantidade de Luzes HID * Correção de Luz HID)',
                'Fluxo Total Mínimo = Volume da Sala / Tempo de Troca',
                'Fluxo Mínimo por Ventilador = Fluxo Total Mínimo / Quantidade de Ventiladores',
            ],

            imageFrequencyToSize: 'Frequência de Imagem para Tamanho',
            storageSpaceNote: 'Determine o espaço de armazenamento necessário para uma determinada taxa de imagem. Mês assume 31 dias.',
            imageSize: 'Tamanho da Imagem',
            captureInterval: 'Intervalo de Captura',
            sizePerDay: 'Tamanho por Dia',
            sizePerWeek: 'Tamanho por Semana',
            sizePerMonth: 'Tamanho por Mês',
            sizePerFourMonths: 'Tamanho por 4 Meses',
            mb: 'MB',

            captureIntervalFromSpaceRestriction: 'Intervalo de Captura devido à Restrição de Espaço',
            determineFastestCaptureInterval: 'Determine o intervalo de captura mais rápido possível dado um espaço de armazenamento limitado.',
            storageSpace: 'Espaço de Armazenamento',
            totalLapseTime: 'Tempo Total do Lapso',
            fastestInterval: 'Intervalo Mais Rápido',
            gb: 'GB',
            days: 'dias',

            weightConvCalcEquations: [
                'Água Usada por Dia = Taxa de Água por Planta * Horas Ligadas por Dia * Quantidade de Plantas',
                'Custo por Dia = Água Usada por Dia * Custo da Água',
                'Água Usada por Mês = Água Usada por Dia * 31',
                'Custo por Mês = Água Usada por Mês * Custo da Água',
            ],
            determineWaterUsageAndCost: 'Determine o uso e custo da água para um determinado número de plantas e taxa de fluxo',
            equationWaterUsedPerDay: 'Água Usada por Dia = Taxa de Água por Planta * Horas Ligadas por Dia * Quantidade de Plantas',
            equationCostPerDay: 'Custo por Dia = Água Usada por Dia * Custo da Água',
            equationWaterUsedPerMonth: 'Água Usada por Mês = Água Usada por Dia * 31',
            equationCostPerMonth: 'Custo por Mês = Água Usada por Mês * Custo da Água',
            waterRatePerPlant: 'Taxa de Água por Planta',
            plantCount: 'Quantidade de Plantas',
            waterCost: 'Custo da Água',
            gph: 'galões/hora (GPH)',
            dollarsPerCubicFoot: 'dólares por ft³',
            waterUsedPerDay: 'Água Usada/Dia',
            waterUsedPerMonth: 'Água Usada/Mês*',
            gallonsPerDay: 'galões/dia',
            gallonsPerMonth: 'galões/mês',

            determineDewPoint: 'Determine o ponto de orvalho.',
            temperature: 'Temperatura',
            relativeHumidity: 'Umidade Relativa',
            dewPoint: 'Ponto de Orvalho',
            dewPointEquations: [
                'Fórmula de Magnus:',
                'Constantes do Ponto de Orvalho são a = 6.112 mb, b = 17.67, c = 243.5 °C (Bolton/Monthly Weather)',
                '[VaporPressureHelperValue = ln(Umidade Rel. / 100) + ((b * Temp) / (c + Temp))]',
                'Ponto de Orvalho/Geada = (c * Valor Auxiliar da Pressão de Vapor) / (b - Valor Auxiliar da Pressão de Vapor)',
            ],

            determinePlantCalendarDates: 'Determine as datas do calendário para momentos importantes na vida das suas plantas',
            plantDate: 'Data do Plantio (AAAA-MM-DD)',
            daysToSprout: 'Dias para Germinar',
            daysVegetative: 'Dias Vegetativos',
            daysFlowering: 'Dias de Floração',
            daysDrying: 'Dias de Secagem',
            daysCuring: 'Dias de Cura',
            daysProcessing: 'Dias de Processamento',
            sprouted: 'Germinado',
            floweringBegins: 'Início da Floração',
            harvest: 'Colheita',
            doneDrying: 'Secagem Concluída',
            doneCuring: 'Cura Concluída',
            doneProcessing: 'Processamento Concluído',

            convertNPKtoPPMDesc: 'Converta os percentuais de nitrogênio, fósforo e potássio ligados à molécula de entrega ("valores NPK" no fertilizante) para PPM TDS em uma determinada proporção de diluição.',
            fertilizerN: 'Fertilizante N',
            fertilizerP: 'Fertilizante P',
            fertilizerK: 'Fertilizante K',
            addedAmount: 'Quantidade Adicionada',
            sgOverride: 'S.G. Ajuste*',
            sgOverrideNote: '*Em casos de uma solução %w/v, insira a densidade específica do fertilizante para corrigir conversões de densidade específica não-1.0.',
            npkMassPercentageNote: 'Composição de porcentagem de massa de NPK elemental em substância de entrega molecular NPK; porcentagem dada de 0,00 a 1,00 inclusiva. Presets assumem elementais presentes como N, P₂O₅ e K₂O.',
            nMassFraction: 'Fração de Massa de N',
            pMassFraction: 'Fração de Massa de P',
            kMassFraction: 'Fração de Massa de K',
            dilutedN: 'N Diluído',
            dilutedP: 'P Diluído',
            dilutedK: 'K Diluído',
            totalDiluted: 'Total Diluído',
            ppmTDS: 'PPM TDS',
            unitEmpty: '',
            mlPerLiter: 'ml fert./litro H₂O',
            NpkToTdsEquations: [
                '[Percentual da Mistura = Quantidade Adicionada / 1000]',
                '[Percentual Final = Percentual da Mistura * Fertilizante N]',
                '[PPM Final = Percentual Final * 10000]',
                'Elemento Diluído = PPM Final * Percentual de Massa * Ajuste de Densidade Específica',
            ],

            adjustPhDescription: 'Ajuste o pH da solução para cima ou para baixo com um pH aditivo conhecido. Alguns pHs aditivos comuns:',
            startPh: 'pH Inicial',
            startVolume: 'Volume Inicial',
            desiredPh: 'pH Desejado',
            additivePh: 'pH do Aditivo',
            startMolarity: 'Mol. Inicial',
            additiveMolarity: 'Mol. do Aditivo',
            desiredMolarity: 'Mol. Desejada',
            additiveVolume: 'Vol. do Aditivo',
            micromoles: 'µmol',
            phConvEquations: [
                'Mol. Inicial = 10e-[pH Inicial] / 1e-6',
                'Mol. do Aditivo = 10e-[pH do Aditivo] / 1e-6',
                'Mol. Desejada = 10e-[pH Desejado] / 1e-6',
                'Vol. do Aditivo = ((Mol. Desejada - Mol. Inicial) * Volume Inicial) / (Mol. do Aditivo - Mol. Inicial)',
                '[Reformulado M₁V₁ + M₂V₂ = M₃V₃ = M₃(V₁ + V₂)]',
            ],

            plantCountCalculatorDescription: 'Esta calculadora fornece layouts quase-ótimos para plantas retangulares.',
            growSpaceWidth: 'Largura do Espaço de Cultivo',
            growSpaceLength: 'Comprimento do Espaço de Cultivo',
            plantWidth: 'Largura da Planta*',
            plantLength: 'Comprimento da Planta*',
            gridLayout: 'Layout da Grade',
            plantsWideBy: 'plantas de largura por',
            plantsLong: 'plantas de comprimento',
            with: 'com',
            plantsInRemainingSpace: 'plantas no espaço restante',
            totalPlants: 'Total de Plantas',
            plants: 'plantas',
            squareFeet: 'pés²',
            usedArea: 'Área Utilizada',
            wastedSpace: 'Espaço Desperdiçado',
            spaceEfficiency: 'Eficiência do Espaço',
            plantCountSpacingNote: '*Lembre-se de adicionar o espaçamento apropriado entre as plantas, que é contado como parte do seu tamanho',

            determineSoilAmounts: 'Determine as quantidades de solo e emenda de solo, escalonadas por vaso.',
            soil1Name: 'Nome do Solo 1',
            soil1AmtPerPot: 'Qtd. de Solo 1/Pote',
            soil2Name: 'Nome do Solo 2',
            soil2AmtPerPot: 'Qtd. de Solo 2/Pote',
            soil3Name: 'Nome do Solo 3',
            soil3AmtPerPot: 'Qtd. de Solo 3/Pote',
            soil4Name: 'Nome do Solo 4',
            soil4AmtPerPot: 'Qtd. de Solo 4/Pote',
            soil5Name: 'Nome do Solo 5',
            soil5AmtPerPot: 'Qtd. de Solo 5/Pote',
            potCount: 'Contagem de Vasos',
            pots: 'vasos',
            totalSoil: 'Total', // Dynamic label, will replace {medium} with the medium name
            SoilCalcEquations: [
                "Total = Qtd. por Pote * Contagem de Vasos",
            ],

            soilMixRatiosDescription: 'Dado certas proporções de mistura de solo, dimensione para fornecer quantidades totais para o número de vasos.',
            potSize: 'Tamanho do Vaso',

            computeDilutionDescription: 'Calcule a diluição necessária para alcançar sólidos dissolvidos alvo. Para diluição com água destilada pura, use TDS Aditivo = 0,00.',
            currentTDS: 'TDS Atual',
            currentVolume: 'Volume Atual',
            targetTDS: 'TDS Alvo',
            additiveTDS: 'TDS Aditivo',
            tdsDilutionsEquations: [
                'Volume Aditivo = ((TDS Alvo - TDS Atual) * Volume Atual) / (TDS Aditivo - TDS Alvo)',
                '[Reformulado C₁V₁ + C₂V₂ = C₃V₃ = C₃(V₁ + V₂)]',
            ],
            
            convertElementalPPMtoNPK: 'Converta de nitrogênio, fósforo e potássio como PPM elementar de uma solução para porcentagens de massa ligadas à molécula de entrega ("números NPK" no fertilizante).',
            fertilizerPPMN: 'Fert. PPM N',
            fertilizerPPMP: 'Fert. PPM P',
            fertilizerPPMK: 'Fert. PPM K',
            massPercentageCompositionNote: 'Composição de porcentagem de massa de NPK elemental em substância de entrega molecular NPK; porcentagem dada de 0,00 a 1,00 inclusiva. Presets assumem elementais presentes como N, P₂O₅ e K₂O.',
            
            nitrogenPercentage: 'N',
            phosphorusPercentage: 'P',
            potassiumPercentage: 'K',
            tdsToNpkEquations: [
                'Percentual do Elemento = (PPM / 10000) / Percentual de Massa',
            ],
            
            vaporPressureDeficitDescription: 'O déficit de pressão de vapor é a diferença entre o conteúdo atual e saturado de umidade do ar e afeta a transpiração da planta. Para a maioria das plantas, um VPD entre 0,4kPa e 1,25kPa é ideal; condições ideais para cannabis variam muito dependendo da fonte, mas geralmente estão em torno de 0,8kPa a 0,12kPa.',
            airTemperature: 'Temperatura do Ar',
            leafTemperature: 'Temperatura da Folha',
            airVPSat: 'Saturação VPS do Ar',
            leafVPSat: 'Saturação VPS da Folha',
            naiveVPD: 'VPD Ingênuo',
            leafVPD: 'VPD da Folha',
            kPa: 'kPa',
            
            vaporPressureDeficitEquations: [
                'Saturação VPS do Ar = 610,78 * e^(tempSalaC / (tempSalaC + 238,2) * 17,2694) / 1000',
                'Saturação VPS da Folha = 610,78 * e^(tempFolhaC / (tempFolhaC + 238,2) * 17,2694) / 1000',
                'VPD Ingênuo = Saturação VPS do Ar * (1 - umidadeRel / 100)',
                'VPD da Folha = Saturação VPS da Folha - Saturação VPS do Ar * umidadeRel / 100',
                'Fonte: https://getpulse.co/blog/vpd',
            ],
            
            computeYieldsDescription: 'Calcule os rendimentos teóricos mínimos, médios e máximos dados um número de plantas.',
            minYieldPerPlant: 'Rendimento Mínimo/Planta',
            avgYieldPerPlant: 'Rendimento Médio/Planta',
            maxYieldPerPlant: 'Rendimento Máximo/Planta',
            minYield: 'Rendimento Mínimo',
            avgYield: 'Rendimento Médio',
            maxYield: 'Rendimento Máximo',
            
            computeYieldsBasedOnHarvestWeights: 'Calcule os rendimentos teóricos mínimos, médios e máximos dados um número de plantas baseado em pesos no momento da colheita.',
            minWetYieldPerPlant: 'Rendimento Úmido Mínimo/Planta',
            avgWetYieldPerPlant: 'Rendimento Úmido Médio/Planta',
            maxWetYieldPerPlant: 'Rendimento Úmido Máximo/Planta',
            dryingLoss: 'Perda na Secagem*',
            dryingLossNote: '*Esta porcentagem é a quantidade de matéria seca da planta comparada à úmida -- por exemplo, 30 gramas secas de 100 gramas úmidas significariam uma Perda na Secagem de 70%. Use nossa calculadora de Mudança de Porcentagem para inserir valores secos e úmidos esperados para chegar a esse número.',
            
            capsuleCalcEquations: [
                "mL Canabinoide no Extrato = Porcentagem do Teste * Volume do Concentrado",
                "Porcentagem da Cápsula do Mix Total = Volume do Recipiente / (Volume do Preenchimento + Volume do Concentrado)",
                "Canabinoide por Cápsula/Cartucho = mL Canabinoide no Extrato * Porcentagem da Cápsula do Mix Total",
                "",
                "Canabinoides por Cápsula/Cartucho = Soma de Todos os Canabinoides por Cápsula/Cartucho",
                "",
                "Cápsulas/Cartuchos Feitos = (Volume do Preenchimento + Volume do Concentrado) / Volume do Recipiente",
            ],
            
            capsuleCannabinoidContentCalculation: 'Calcule o conteúdo de canabinoides da cápsula ou cartucho baseado na análise laboratorial.',
            concentrateVolume: 'Vol. do Concentrado*',
            fillerVolume: 'Vol. do Preenchimento',
            containerVolume: 'Vol. da Cápsula/Cartucho',
            extractTestResults: 'Resultados do Teste do Extrato',
            THC: 'THC',
            THCa: 'THCa',
            delta8THC: 'Δ-8 THC',
            CBD: 'CBD',
            CBN: 'CBN',
            CBG: 'CBG',
            capCartTHC: 'THC da Cápsula/Cartucho*',
            capCartTHCa: 'THCa da Cápsula/Cartucho*',
            capCartDelta8THC: 'Δ-8 THC da Cápsula/Cartucho*',
            capCartCBD: 'CBD da Cápsula/Cartucho*',
            capCartCBN: 'CBN da Cápsula/Cartucho*',
            capCartCBG: 'CBG da Cápsula/Cartucho*',
            capCartTotalCannabinoids: 'Canabinoides da Cápsula/Cartucho*',
            capsCartsMade: 'Cápsulas/Cartuchos Feitos',
            CapsuleCalcApproximateConversionNote: '*1 mL ≈ 1 g para água, que pode ser usado como uma conversão aproximada se o volume exato não for conhecido. Se preencher por peso, mL pode ser lido como mg onde quer que a unidade apareça.',
            
            decarboxylationCalculationDescription: 'Isso determina o tempo aproximado para a decarboxilação completa de material de cannabis seco baseado em dados de fontes científicas (mais informações no bloco de equação). Estes números são uma estimativa e podem variar com base na potência da planta, densidade e hidratação. Não há dados disponíveis para temperaturas inferiores a 100°C; resultados são confiáveis abaixo desse ponto.',
            decarbTimeLabel: 'Tempo de Decarb ~100%',
            
            decarbCurveEquations: [
                "Curva de melhor ajuste de potência determinada a partir dos pontos de dados das seguintes fontes (identificadas por DOI e autor):",
                "10.1016/j.forsciint.2015.07.019 (Taschwer et. al.)",
                "   180min a 100°C",
                "   60min a 150°C",
                "10.1055/s-0031-1298334 (Eichler, et. al.)",
                "   12min a 140°C",
                "   5min a 210°C",
                "US7344736B2 (Patente)",
                "   240min a 105°C",
                "   120min a 120°C",
                "   60min a 140°C",
                "",
                "Melhor ajuste de potência: Tempo [minutos] = 4e+12 * (Temperatura [°C])^-5.117",
            ],
            decarboxylationDescription: 'Calcule o conteúdo de canabinoides da cápsula ou cartucho baseado na análise laboratorial.',
            thcaLossTitle: 'Perda de THCa Apenas',
            thcaLossDescription: 'Ao decarboxilar a cannabis, a reação importante é a conversão do ácido tetrahidrocanabinólico (THCa) em tetrahidrocanabinol (THC), o químico real que é psicoativo. A decarboxilação resulta na perda de um dióxido de carbono, causando uma queda no peso molecular (358.4733 g/mol - 314.45 g/mol = 44.0233 g/mol de perda (~12.22% de perda)). Esta calculadora permite determinar o THC restante após a decarboxilação dado os níveis de THCa pré-decarb. Note que não leva em conta a perda de peso molar devido à CBDA para CBD, CBGA para CBG, etc., que são menos tipicamente conhecidos para amostras de flor.',
            productTHCaContent: 'Conteúdo de THCa do Produto',
            postDecarbTHCContent: 'Conteúdo de THC Pós-Decarb',
            productBasedLossTitle: 'Perda Baseada no Produto',
            productAmount: 'Quantidade do Produto',
            productTHCaPercentage: 'Porcentagem de THCa do Produto',
            preDecarbTHC: 'THC Pré-Decarb',
            postDecarbTHC: 'THC Pós-Decarb',
            milligrams: 'mg',
            mgPerGram: 'mg/g',

            decarbLossEquations: [
                "Conteúdo de THC Pós-Decarb = Conteúdo de THCa do Produto * (314.45 / 358.4733)"
            ],

            mgPerServingTitle: 'mg/Porção',
            mgPerServingDescription: 'Determine a potência da porção dado o produto/potência usada assumindo 100% de extração de THC.',
            productPotency: 'Potência do Produto',
            servings: 'Porções',
            decarbCorrectionLabel: 'Corrija para perdas de decarboxilação',
            mgTHCPerServing: 'mg THC/porção',
            percentTHC: '% THC',
            EdiblePotencyEquations: [
                "mg THC/porção = (Quantidade do Produto * Potência do Produto) / Porções"
            ],

            productAmountTitle: 'Quantidade do Produto',
            productAmountDescription: 'Determine a quantidade de produto necessária para uma potência dada assumindo 100% de extração de THC.',
            productNeeded: 'Produto Necessário',
            edibleProductEquations: [
                "THC Necessário = Porções * mg Por Porção",
                "Produto Necessário = THC Necessário / Potência do Produto",
            ],

            servingCountTitle: 'Contagem de Porções',
            servingCountDescription: 'Determine a contagem de porções dada a potência da porção desejada e a quantidade/potência do produto assumindo 100% de extração de THC.',
            servingsOutput: 'Porções',
            edibleServingEquations: [
                "Porções = (Quantidade do Produto * Potência) / mg THC por Porção"
            ],

            solventEvaporationCalculatorDescription: 'Para usar esta calculadora, meça o peso do solvente que está usando antes de introduzi-lo à cannabis. Após um tempo, pese novamente e anote o novo peso. Estime o rendimento aproximado do produto como um fator de correção (ou meça o peso do solvente antes e depois do contato com a cannabis para um valor mais preciso), e então esta calculadora irá prever (assumindo uma taxa de evaporação linear) a quantidade aproximada de tempo que levará para o solvente restante evaporar. Por favor, note que isso é muito impreciso e deve ser usado apenas para estimativas vagas; a verdadeira evaporação do solvente nem sempre é linear.',
            preCannabisSolventWeight: 'Peso do Solvente Pré-cannabis',
            currentSolventWeight: 'Peso Atual do Solvente',
            timeSinceStart: 'Tempo Desde o Início',
            estimatedYield: 'Rendimento Estimado',
            evaporatedSolvent: 'Solvente Evaporado',
            solventLossPerHour: 'Perda de Solvente/hr',
            timeToTotalEvaporation: 'Tempo para Evaporação Total',

            evapPredictionEquations: [
                "[Peso Atual do Solvente Corrigido = Peso Atual do Solvente - Rendimento Estimado]",
                "Solvente Evaporado = Peso do Solvente Pré-cannabis - Peso Atual do Solvente Corrigido",
                "Perda de Solvente por Hora = Solvente Evaporado / Tempo Desde o Início",
                "Tempo para Evaporação Total = Peso Atual do Solvente Corrigido / Perda de Solvente por Hora"
            ],

            extractionEfficiencyDescription: 'Ao fazer extratos, a eficiência do processo (quanto extrato é produzido por unidade de matéria-prima) é importante, mas muito superada pela eficiência da extração - quanto do THC presente na matéria-prima chega ao extrato. Por exemplo, um processo pode produzir menos extrato, mas conter uma concentração mais alta de THC do que um processo diferente, pois extrai mais THC e menos resíduos (clorofila, etc.) da planta. A eficiência da extração determina a porcentagem de THC extraída, produzindo uma métrica mais confiável para avaliar processos de extração.',
            feedstockWeight: 'Peso da Matéria-Prima',
            feedstockTHCContent: 'Conteúdo de THC da Matéria-Prima',
            extractWeight: 'Peso do Extrato',
            extractTHCContent: 'Conteúdo de THC do Extrato',
            weightYield: 'Rendimento de Peso',
            totalFeedstockTHC: 'Total de THC da Matéria-Prima',
            totalExtractTHC: 'Total de THC do Extrato',
            extractionEfficiency: 'Eficiência da Extração',
            extractionEfficiencyEquations: [
                "Rendimento de Peso = Peso do Extrato / Peso da Matéria-Prima",
                "Total de THC da Matéria-Prima = Conteúdo de THC da Matéria-Prima * Peso da Matéria-Prima",
                "Total de THC do Extrato = Conteúdo de THC do Extrato * Peso do Extrato",
                "Eficiência da Extração = Total de THC do Extrato / Total de THC da Matéria-Prima",
            ],

            oilButterPotencyTitle: 'Potência de Óleo/Manteiga',
            oilButterPotencyDescription: 'Determine a potência de um óleo ou manteiga preparado especificamente para uma receita assumindo 100% de extração de THC.',
            oilButterInfused: 'Óleo/Manteiga Infundido',
            oilButterTotalTHC: 'THC Total do Óleo/Manteiga',
            oilButterTHCPerTablespoon: 'THC do Óleo/Manteiga por colher de sopa',
            oilButterTHCPerTeaspoon: 'THC do Óleo/Manteiga por colher de chá',
            mgPerTablespoon: 'mg/colher de sopa',
            mgPerTeaspoon: 'mg/colher de chá',

            oilButterPotencyEquations: [
                "THC Total do Óleo = Quantidade do Produto * Potência",
                "THC do Óleo por quantidade = THC Total do Óleo / Óleo Infundido",
            ],

            partialOilButterBlendTitle: 'Mistura Parcial de Óleo/Manteiga',
            partialOilButterBlendDescription: 'Determine a mistura de manteiga/óleo medicado com manteiga/óleo regular para receitas com uma dosagem desejada conhecida, mas onde usar somente manteiga/óleo medicado resultaria em uma dosagem muito potente.',
            medicatedOilPotency: 'Potência do Óleo Medicinal',
            recipeOilCalledFor: 'Óleo Requerido na Receita',
            desiredServings: 'Porções Desejadas',
            desiredPotency: 'Potência Desejada',
            medicatedOilAmount: 'Quantidade de Óleo Medicado',
            regularOilAmount: 'Quantidade de Óleo Regular',
            mgTHCPerTablespoon: 'mg THC/colher de sopa',
            tablespoons: 'colheres de sopa',
            mgPerServing: 'mg/porção',

            partialOilButterEquations: [
                "Quantidade de Óleo Medicado = Contagem de Porções * THC por Porção / Potência do Óleo Medicado",
                "Óleo Regular = Óleo Total Necessário - Quantidade de Óleo Medicado",
            ],

            additiveAmountCalculationDescription: 'Resolve a quantidade de aditivo em casos em que o aditivo pode ser, no máximo, uma determinada porcentagem da constituição final (por exemplo, muitos aditivos de terpeno recomendam não mais de 5% da constituição final da mistura; dados 200g de concentrado, você pode, portanto, adicionar 10.526g de terpenos).',
            startAmount: 'Quantidade Inicial',
            finalPercentageOfAdditive: 'Porcentagem Final do Aditivo',
            additiveAmountOutput: 'Quantidade de Aditivo',
            totalAmountOutput: 'Quantidade Total',
            percentConstituentEquations: [
                "Quantidade Total = Quantidade Inicial / (100 - Porcentagem Final do Aditivo)",
                "Quantidade de Aditivo = Quantidade Total - Quantidade Inicial"
            ],

            knownIngredientsTitle: 'Ingredientes Conhecidos',
            knownIngredientsDescription: 'Determine a quantidade e potência de uma salada final dada as entradas conhecidas.',
            product1: 'Produto 1',
            product2: 'Produto 2',
            product3: 'Produto 3',
            product4: 'Produto 4',
            thc: 'THC',
            cbd: 'CBD',
            finalProduct: 'Produto Final',
            totalTHC: 'THC Total',
            totalCBD: 'CBD Total',
            thcToCbdRatio: 'Proporção: 1THC para',
            percentCBD: '% CBD',
            cbdUnit: 'CBD',

            saladGeneratorTitle: 'Gerador de Salada',
            saladGeneratorDescription: 'Determine a mistura de opções que mais se aproxima da proporção desejada.',
            oneTHCTo: '1 THC para',
            maxElements: 'Máx. Elementos',
            minimumTHC: 'THC Mín.',
            productLabel: 'Produto',
            thcPercentage: '% THC',
            cbdPercentage: '% CBD',
            grams: 'g',
            cantMakeBlend: "Não é possível fazer essa mistura!",

            thcPotencycalculatorSectionDescription: 'Escolha a seção apropriada da calculadora para suas unidades. mg e g são usados como unidades analíticas padrão; se seus valores iniciais estiverem em uma unidade diferente, use nossa calculadora de Conversão de Peso.',
            percentageTHC: 'Porcentagem de THC',
            mgTHCPerGram: 'mg THC por Grama',
            mgTHCPerGramInput: 'mg THC/grama',
            percentageTHCOutput: 'Porcentagem de THC',
            productVolume: 'Volume do Produto',
            productDensity: 'Densidade do Produto',
            mgMLTHC: 'mg/mL THC',
            mgGTHC: 'mg/g THC',
            thcPercentageOutput: 'Porcentagem de THC',
            productWeight: 'Peso do Produto',
            mgTHCPerGramOutput: 'mg THC por Grama',
            milliliters: 'mL',
            gramsPerMilliliter: 'g/mL',

            variableServingPotencyTitle: 'Receita Completa (Flores, Volume)',
            variableServingPotencyDescription: 'Determine a porção e a potência da quebra de um óleo ou manteiga preparado especificamente para uma receita assumindo 100% de extração de THC.',
            bakedGoodOilAmount: 'Quant. de Óleo de Produto Assado',
            bakedGoodServings: 'Porções de Produto Assado',
            bakedGoodTotalTHC: 'THC Total do Produto Assado',
            thcPerServing: 'THC/Porção',
            variableServingPotencyVolumeNote: '*Esta porcentagem é a quantidade de matéria seca da planta comparada à úmida -- por exemplo, 30 gramas secas de 100 gramas úmidas significariam uma Perda de 70% na Secagem. Use nossa calculadora de Mudança de Porcentagem para inserir valores secos e úmidos esperados para chegar a esse número.',
            variableServingPotencyVolumeEquations: [
                "THC Total do Óleo = Quantidade do Produto * Potência",
                "THC do Óleo por colher de sopa = THC Total do Óleo / Óleo Infundido",
                "THC Total do Produto Assado = THC do Óleo por colher de sopa * Quant. de Óleo de Produto Assado (em colheres de sopa)",
                "THC por Porção = THC Total do Produto Assado / Porções",
            ],

            completeRecipeOilButterVolumeTitle: 'Receita Completa (Óleo/Manteiga, Volume)',
            completeRecipeOilButterVolumeDescription: 'Determine a quebra de porção e potência de um comestível feito com um óleo/manteiga medicado conhecido.',
            oilButterPotency: 'Potência de Óleo/Manteiga',
            mgPerCup: 'mg/xícara',
            variableServPotenVolumeButteEquations: [
                "THC Total do Produto Assado = THC do Óleo por quantidade * Quant. de Óleo de Produto Assado",
                "THC por Porção = THC Total do Produto Assado / Porções",
            ],

            completeRecipeFlowersWeightTitle: 'Receita Completa (Flores, Peso)',
            completeRecipeFlowersWeightDescription: 'Determine a quebra de porção e potência de um óleo ou manteiga preparado especificamente para uma receita assumindo 100% de extração de THC.',

            oilButterInfusedWeight: 'Óleo/Manteiga Infundido',
            bakedGoodOilAmountWeight: 'Quant. de Óleo de Produto Assado',
            oilButterTHCPerGram: 'THC do Óleo/Manteiga/grama',
            variableServPotencyWeightEquations: [
                "THC Total do Óleo = Quantidade do Produto * Potência",
                "THC do Óleo por g = THC Total do Óleo / Óleo Infundido",
                "THC Total do Produto Assado = THC do Óleo por g * Quant. de Óleo de Produto Assado (em colheres de sopa)",
                "THC por Porção = THC Total do Produto Assado / Porções"
            ],


        },

        // Spanish

        es:{
            headings: {
                generalCannabisGrowingCalculators: 'Calculadoras y Conversiones Generales para el Cultivo de Cannabis',
                WeightConversion: 'Conversión de Peso',
                DistanceConversion: 'Conversión de Distancia',
                TemperatureConversion: 'Conversión de Temperatura',
                SpeedConversion: 'Conversión de Velocidad',
                AreaConversion: 'Conversión de Área',
                VolumeConversion: 'Conversión de Volumen',
                FlowRateConversion: 'Conversión de Caudal',
                TimeConversion: 'Conversión de Tiempo',
                DateCalculator: 'Calculadora de Fecha',
                ECTDSConversion: 'Conversión de EC/TDS',
                TrimmingTimePredictionCalculator: 'Calculadora de Predicción de Tiempo de Poda',
                PercentageCalculator: 'Calculadora de Porcentajes',
                CylinderDuctingVolume: 'Volumen de Conducto Cilíndrico',
                CannabisLightingPowerWaterCalculators: 'Calculadoras de Iluminación/Potencia/Agua para Cannabis',
                LightWattageLumens: 'Potencia de Luz/Lúmenes',
                DeliveredLumens: 'Lúmenes Entregados',
                BTUsGeneratedHeatOffsetCalculator: 'Calculadora de BTUs Generados/Compensación de Calor',
                CO2FlowRate: 'Caudal de CO₂',
                ExhaustCFMCalculator: 'Calculadora de CFM de Escape',
                LightKWhCost: 'Costo y kWh de Luz',
                WaterUsageDripTipFlowCost: 'Uso de Agua/Costo de Flujo de Goteo',
                TimeLapseImageSize: 'Tamaño de Imagen de Lapso de Tiempo',
                CannabisGrowingFertilizerAgricultureCalculators: 'Calculadoras de Cultivo/Fertilizante/Agricultura de Cannabis',
                DewPoint: 'Punto de Rocío',
                VaporPressureDeficitCalculator: 'Calculadora de Déficit de Presión de Vapor (VPD)',
                ProjectedGrowthTimelineCalendar: 'Calendario/Cronograma de Crecimiento Proyectado',
                PlantLayout: 'Diseño de Planta',
                SoilAmountToTotal: 'Cantidad de Suelo al Total',
                SoilRatioToTotal: 'Proporción de Suelo al Total',
                PHWaterAdjustment: 'Ajuste de pH/Agua',
                NPKToPPMTDS: 'NPK a PPM TDS',
                PPMTDSToNPM: 'PPM TDS a NPM',
                DilutionToTDSTarget: 'Dilución a Objetivo TDS',
                GeneralCropYield: 'Rendimiento General de Cultivos',
                DryWetYield: 'Rendimiento Seco/Húmedo',
                EdibleCalculatorsConcentratesBlending: 'Calculadoras de Comestibles, Concentrados y Mezcla',
                EdiblePotency: 'Potencia de Comestibles',
                OilButterPotency: 'Potencia de Aceite/Mantequilla',
                THCPotencyConversions: 'Conversiones de Potencia THC',
                SaladsBlending: 'Ensaladas y Mezcla',
                DecarboxylationLoss: 'Pérdida por Decarboxilación',
                DecarboxylationCurvePrediction: 'Predicción de Curva de Decarboxilación',
                ExtractionEfficiency: 'Eficiencia de Extracción',
                SolventEvaporationTimeEstimate: 'Estimación de Tiempo de Evaporación de Solvente',
                ConcentrateToCapsuleTHCBreakdown: 'Desglose de THC de Concentrado a Cápsula',
                MaxPercentConstituentTerpeneAddition: 'Adición Máxima de Terpeno Constituyente (Porcentaje)'
            },
            Equations: 'Ecuaciones',
            minusSign: '-',
            plusSign: '+',
            whenSplit: 'cuando se divide',
            ways: 'formas',
            examplePerPlantOrPerRoom: 'por ejemplo, por planta o por sala',
            Area: 'Área',
            CylinderCalcDescription: '*Cuando se usa el volumen del cilindro para determinar el volumen total de ductos, usar la longitud total de los ductos como Altura.',
            Radius: 'Radio',
            Height: 'Altura',
            Volume: 'Volumen',
            units3: 'Unidades³',
            StartDate: 'Fecha de Inicio (AAAA-MM-DD)',
            StartTime: 'Hora de Inicio (HH:MM:SS)',
            Add: 'Agregar',
            Subtract: 'Restar',
            Years: 'Años',
            Months: 'Meses',
            Days: 'Días',
            Hours: 'Horas',
            Minutes: 'Minutos',
            Seconds: 'Segundos',
            AdjustedDate: 'Fecha Ajustada',
            AdjustedTime: 'Hora Ajustada',
            InvalidInput: 'Entrada Inválida',
            dateCalcDesc: 'Agregar o restar fechas de una fecha de inicio dada',
            Distance: 'Distancia',
            EC_TDS: 'EC/TDS',
            FlowRate: 'Caudal',
            Input: 'Entrada',
            Output: 'Salida',
        
            determineIllumination: 'Determinar la iluminación necesaria para un área dada.',
            desiredLumens: 'Lúmenes Deseados*',
            desiredWatts: 'Vatios Deseados',
            growAreaWidth: 'Ancho del Área de Cultivo',
            growAreaLength: 'Largo del Área de Cultivo',
            illuminationNeeded: 'Iluminación Necesaria',
            wattsNeeded: 'Vatios Necesarios',
            lumensWattsNote: '*Aunque los lúmenes son una medida más precisa de la salida de luz real, los vatios se han convertido en un estándar de facto -- en caso de duda, usar vatios y desconsiderar lúmenes.',
            lightingEquations: [
                'Iluminación Necesaria = Ancho del Área de Cultivo * Largo del Área de Cultivo * Lúmenes Deseados',
                'Vatios Necesarios = Ancho del Área de Cultivo * Largo del Área de Cultivo * Potencia Deseada'
            ],
            lumens: 'lúmenes',
            watts: 'vatios',
        
            linearCalculatorExplanation: 'Este calculador se generaliza para cualquier tarea lineal (es decir, si te toma una hora hacer dos, te tomará dos horas para cuatro y tres horas para seis, etc.).',
            amountDone: 'Cantidad Realizada',
            timeTakenSoFar: 'Tiempo Transcurrido Hasta Ahora',
            amountLeft: 'Cantidad Restante',
            workPace: 'Ritmo de Trabajo',
            timeToCompletion: 'Tiempo para la Finalización',
            units: 'Unidades',
            units_hr: 'Unidades/hora',
            linearCalcEquations: [
                'Ritmo de Trabajo = Cantidad Completada / Tiempo Transcurrido Hasta Ahora',
                'Tiempo para la Finalización = Cantidad Restante / Ritmo de Trabajo'
            ],

            before: 'Antes',
            after: 'Después',
            change: 'Cambio',

            Speed: 'Velocidad',
            Temperature: 'Temperatura',

            Time: 'Tiempo',
            Weight: 'Peso',

            determineLumens: 'Determinar los lúmenes por área proporcionados por las luces dadas.',
            roomArea: 'Área del Cuarto',
            light1Lumens: 'Lúmenes de Luz 1',
            light1Count: 'Cantidad de Luz 1',
            light2Lumens: 'Lúmenes de Luz 2',
            light2Count: 'Cantidad de Luz 2',
            light3Lumens: 'Lúmenes de Luz 3',
            light3Count: 'Cantidad de Luz 3',
            light4Lumens: 'Lúmenes de Luz 4',
            light4Count: 'Cantidad de Luz 4',
            roomAreaOutput: 'Área del Cuarto',
            totalIllumination: 'Iluminación Total',
            illuminationPerFtSq: 'Iluminación por ft²',
            lights: 'luces',
            ftSq: 'ft²',
            lumensPerFtSq: 'lúmenes/ft²',
            DeliveredLightingEquations: [
                'Iluminación Total = suma(Conteo de Luz X * Lúmenes de Luz X)',
                'Iluminación por Área = Iluminación Total / Área'
            ],

            ampCalcImportantNote: 'Nota importante:',
            wattageExplanation: 'el vataje mencionado aquí no es el vataje de salida de luz (es decir, cuán brillantes son las luces). Esto se refiere al vataje en el verdadero sentido de potencia consumida por las luces. Esta información suele encontrarse en la hoja de datos de sus luces. Si no se encuentra el vataje, puede calcularlo multiplicando la amperaje que consumen las luces por el voltaje (generalmente 120 en EE. UU.). Por ejemplo, una luz que consume 5 amperios de potencia consumiría 600 vatios (5 amperios * 120 voltios).',
            monthAssumption: 'Mes asume 31 días.',
            singleLightWattage: 'Vataje de Luz Única',
            voltage: 'Voltaje',
            dollarCostPerKWh: 'Costo en Dólares por kWh',
            hoursOnPerDay: 'Horas Encendidas por Día',
            lightCount: 'Conteo de Luces',
            totalAmperage: 'Amperaje Total',
            powerPerDay: 'Potencia por Día',
            costPerDay: 'Costo/Día',
            powerPerMonth: 'Potencia por Mes',
            costPerMonth: 'Costo/Mes',
            volts: 'voltios',
            dollars: 'dólares',
            hours: 'horas',
            amps: 'amperios',
            kWhPerDay: 'kWh/día',
            dollarSign: '$',
            kWhPerMonth: 'kWh/mes',
            ampCalcEquations: [
                'Amperaje Total = Vataje de Luz Única / Voltaje * Conteo de Luces',
                'Potencia por Día (kW) = Vataje de Luz Única * Horas Encendidas por Día * Conteo de Luces / 1000',
                'Costo por Día = Potencia por Día * Costo en Dólares por kWh',
                'Potencia por Mes = Potencia por Día * 31',
                'Costo por Mes = Potencia por Mes * Costo en Dólares por kWh'
            ],

            BtuImportantNote: 'Nota importante:',
            BtuWattageExplanation: 'el vataje mencionado aquí no es el vataje de salida de luz (es decir, cuán brillantes son las luces). Esto se refiere al vataje en el verdadero sentido de potencia consumida por las luces. Esta información suele encontrarse en la hoja de datos de sus luces. Si no se encuentra el vataje, puede calcularlo multiplicando la amperaje que consumen las luces por el voltaje (generalmente 120 en EE. UU.). Por ejemplo, una luz que consume 5 amperios de potencia consumiría 600 vatios (5 amperios * 120 voltios).',
            btuCalculationAssumption: 'Las cálculos de BTU asumen 3.412 BTUs/Vatio',
            co2GeneratorBTUs: 'BTUs de Generador de CO₂',
            co2Generators: 'Generadores de CO₂',
            dehumidifierWattage: 'Vataje de Deshumidificador',
            dehumidifiers: 'Deshumidificadores',
            btusPerHour: 'BTUs/Hora',
            btus: 'BTUs',
            generators: 'generadores',
            BtcCalcEquations: [
                'BTUs por Vatio = 3.4.12',
                'Vataje Total de Luz = Vataje de Luz Única * Conteo de Luces',
                'BTUs Totales de CO₂ = BTUs de Generador de CO₂ * Conteo de Generadores',
                'Vataje Total de Deshumidificador = Vataje de Deshumidificador * Conteo de Deshumidificadores',
                'BTUs por Hora = (Vataje Total de Luz + Vataje Total de Deshumidificador) * BTUs por Vatio + BTUs Totales de CO₂'
            ],

            determineCO2FlowRate: 'Determinar la tasa de flujo de CO₂ necesaria para la suplementación de CO₂ a la concentración deseada.',
            co2SafetyNote: 'El CO₂ es un asfixiante y puede matar. Siempre practique la seguridad adecuada al utilizar CO₂ y equipos generadores de CO₂.',
            roomWidth: 'Ancho del Cuarto',
            roomLength: 'Largo del Cuarto',
            roomHeight: 'Altura del Cuarto',
            volumeCompensation: 'Compensación de Volumen',
            ambientCO2: 'CO₂ Ambiental',
            desiredCO2: 'CO₂ Deseado',
            minutesOn: 'Minutos Encendido',
            roomVolume: 'Volumen del Cuarto',
            desiredAdditionalCO2: 'CO₂ Adicional Deseado',
            fixedAdditionalCO2: 'CO₂ Adicional Fijo',
            co2FlowRatePerHour: 'Tasa de Flujo de CO₂ (por hora)',
            co2FlowRatePerMinute: 'Tasa de Flujo de CO₂ (por minuto)',
            ppm: 'ppm',
            minutes: 'minutos',
            ftCubed: 'ft³',
            ftCubedPerHour: 'ft³/hora',
            scfh: 'SCFH (ft³/hora)',
            scfm: 'SCFM (ft³/minuto)',
            Co2RoomVolumeNote: '*El volumen del cuarto no considera el espacio ocupado por ductos, ventiladores, soportes de plantas, etc. -- ingrese el volumen aproximado consumido por objetos en el cuarto aquí para aumentar la precisión del volumen. Para ductos, use la calculadora de Volumen Cilíndrico con la longitud de los ductos como altura del cilindro.',
            co2CalcEquations: [
                'Volumen del Cuarto = Ancho * Largo * Altura - Compensación de Volumen',
                'CO₂ Adicional Deseado = CO₂ Deseado - CO₂ Ambiental',
                'CO₂ Adicional Fijo = (CO₂ Adicional Deseado * 1e-6) * Volumen del Cuarto',
                'Tasa de Flujo de CO₂ = Tasa de Flujo de CO₂ Fijo / (Minutos Encendido / 60)'
            ],

            airflowNote: 'Tenga en cuenta que esto es para flujo de aire puro; esto no tiene en cuenta la pérdida de presión debido a curvas en los ductos, polvo, etc., que es altamente específico del ducto y su disposición.',
            fanCount: 'Conteo de Ventiladores',
            exchangeTime: 'Tiempo de Intercambio',
            compensationFactorNote: 'Algunos sitios recomiendan agregar un factor de compensación para fuentes de alto calor o resistencia al flujo de aire como luces HID y filtros de carbono. Puede especificar la corrección y el número de tales dispositivos aquí, si lo desea; el volumen del cuarto se ajustará en el porcentaje dado para cada dispositivo. Se han proporcionado factores comunes.',
            carbonFilterCount: 'Conteo de Filtros de Carbono',
            carbonFilterCorrection: 'Corrección de Filtro de Carbono',
            oneKWHIDLightCount: 'Conteo de Luces HID de 1kW',
            oneKWHIDLightCorrection: 'Corrección de Luz HID de 1kW',
            roomVolumeCorrected: 'Volumen del Cuarto*',
            minTotalFlow: 'Flujo Total Mínimo',
            minFanFlowEach: 'Flujo Mínimo por Ventilador',
            correctedForFiltersOrHIDLamps: '*Corregido por cualquier filtro o lámparas HID dado',
            fans: 'ventiladores',
            minutesTotalAirFlush: 'minutos para el vaciado total del aire',
            filters: 'filtros',
            percent: '%',
            exhaustCalcEquations: [
                'Volumen del Cuarto = (Ancho * Largo * Altura) + (Conteo de Filtros de Carbono * Corrección de Filtro de Carbono) + (Conteo de Luces HID * Corrección de Luz HID)',
                'Flujo Total Mínimo = Volumen del Cuarto / Tiempo de Intercambio',
                'Flujo Mínimo por Ventilador = Flujo Total Mínimo / Conteo de Ventiladores'
            ],

            imageFrequencyToSize: 'Frecuencia de Imagen a Tamaño',
            storageSpaceNote: 'Determine el espacio de almacenamiento necesario para una tasa de imágenes dada. Mes asume 31 días.',
            imageSize: 'Tamaño de Imagen',
            captureInterval: 'Intervalo de Captura',
            sizePerDay: 'Tamaño por Día',
            sizePerWeek: 'Tamaño por Semana',
            sizePerMonth: 'Tamaño por Mes',
            sizePerFourMonths: 'Tamaño por 4 Meses',
            mb: 'MB',

            captureIntervalFromSpaceRestriction: 'Intervalo de Captura por Restricción de Espacio',
            determineFastestCaptureInterval: 'Determine el intervalo de captura más rápido posible dado un espacio de almacenamiento limitado.',
            storageSpace: 'Espacio de Almacenamiento',
            totalLapseTime: 'Tiempo Total de Lapso',
            fastestInterval: 'Intervalo Más Rápido',
            gb: 'GB',
            days: 'días',

            weightConvCalcEquations: [
                'Agua Usada por Día = Tasa de Agua por Planta * Horas Encendidas por Día * Conteo de Plantas',
                'Costo por Día = Agua Usada por Día * Costo del Agua',
                'Agua Usada por Mes = Agua Usada por Día * 31',
                'Costo por Mes = Agua Usada por Mes * Costo del Agua'
            ],
            determineWaterUsageAndCost: 'Determine el uso y costo del agua para un número dado de plantas y tasa de flujo',
            equationWaterUsedPerDay: 'Agua Usada por Día = Tasa de Agua por Planta * Horas Encendidas por Día * Conteo de Plantas',
            equationCostPerDay: 'Costo por Día = Agua Usada por Día * Costo del Agua',
            equationWaterUsedPerMonth: 'Agua Usada por Mes = Agua Usada por Día * 31',
            equationCostPerMonth: 'Costo por Mes = Agua Usada por Mes * Costo del Agua',
            waterRatePerPlant: 'Tasa de Agua por Planta',
            plantCount: 'Conteo de Plantas',
            waterCost: 'Costo del Agua',
            gph: 'gal/hr (GPH)',
            dollarsPerCubicFoot: 'dólares por ft³',
            waterUsedPerDay: 'Agua Usada/Día',
            waterUsedPerMonth: 'Agua Usada/Mes*',
            gallonsPerDay: 'gal/día',
            gallonsPerMonth: 'gal/mes',

            determineDewPoint: 'Determine el punto de rocío.',
            temperature: 'Temperatura',
            relativeHumidity: 'Hum. Relativa',
            dewPoint: 'Punto de Rocío',
            dewPointEquations: [
                'Fórmula de Magnus:',
                'Las constantes del Punto de Rocío son a = 6.112 mb, b = 17.67, c = 243.5 °C (Bolton/Weather Mensual)',
                '[ValorAuxiliarPresiónVapor = ln(HumRel. / 100) + ((b * Temp) / (c + Temp))]',
                'Punto de Rocío/Helada = (c * ValorAuxiliarPresiónVapor) / (b - ValorAuxiliarPresiónVapor)'
            ],

            determinePlantCalendarDates: 'Determine las fechas del calendario para tiempos importantes en la vida de sus plantas',
            plantDate: 'Fecha de Plantación (AAAA-MM-DD)',
            daysToSprout: 'Días para Germinar',
            daysVegetative: 'Días Vegetativos',
            daysFlowering: 'Días de Floración',
            daysDrying: 'Días de Secado',
            daysCuring: 'Días de Curación',
            daysProcessing: 'Días de Procesamiento',
            sprouted: 'Germinado',
            floweringBegins: 'Inicio de la Floración',
            harvest: 'Cosecha',
            doneDrying: 'Secado Completo',
            doneCuring: 'Curación Completa',
            doneProcessing: 'Procesamiento Completo',

            convertNPKtoPPMDesc: 'Convierte los porcentajes de nitrógeno, fósforo y potasio unidos a la molécula de entrega ("valores NPK" en fertilizantes) a PPM TDS en una relación de dilución dada.',
            fertilizerN: 'Fertilizante N',
            fertilizerP: 'Fertilizante P',
            fertilizerK: 'Fertilizante K',
            addedAmount: 'Cantidad Añadida',
            sgOverride: 'S.G. Override*',
            sgOverrideNote: '*En casos de una solución %w/v, ingrese la gravedad específica del fertilizante para corregir conversiones no-1.0 S.G.',
            npkMassPercentageNote: 'Composición porcentual de masa de NPK elemental en sustancia de entrega molecular NPK; porcentaje dado 0.00 - 1.00 inclusive. Los valores predeterminados asumen elementales presentes como N, P₂O₅ y K₂O.',
            nMassFraction: 'Fracción de Masa de N',
            pMassFraction: 'Fracción de Masa de P',
            kMassFraction: 'Fracción de Masa de K',
            dilutedN: 'N Diluido',
            dilutedP: 'P Diluido',
            dilutedK: 'K Diluido',
            totalDiluted: 'Total Diluido',
            ppmTDS: 'PPM TDS',
            unitEmpty: '',
            mlPerLiter: 'ml fert./litro H₂O',
            NpkToTdsEquations: [
                '[Porcentaje de Mezcla = Cantidad Añadida / 1000]',
                '[Porcentaje Final = Porcentaje de Mezcla * Fertilizante N]',
                '[PPM Final = Porcentaje Final * 10000]',
                'Elemento Diluido = PPM Final * Porcentaje de Masa * S.G. Override'
            ],

            adjustPhDescription: 'Ajustar el pH de una solución hacia arriba o hacia abajo con un pH aditivo conocido. Algunos pH aditivos comunes:',
            startPh: 'pH Inicial',
            startVolume: 'Volumen Inicial',
            desiredPh: 'pH Deseado',
            additivePh: 'pH del Aditivo',
            startMolarity: 'Mol. Inicial',
            additiveMolarity: 'Mol. del Aditivo',
            desiredMolarity: 'Mol. Deseado',
            additiveVolume: 'Vol. del Aditivo',
            micromoles: 'µmol',
            phConvEquations: [
                'Mol. Inicial = 10e-[pH Inicial] / 1e-6',
                'Mol. del Aditivo = 10e-[pH del Aditivo] / 1e-6',
                'Mol. Deseado = 10e-[pH Deseado] / 1e-6',
                'Vol. del Aditivo = ((Mol. Deseado - Mol. Inicial) * Volumen Inicial) / (Mol. del Aditivo - Mol. Inicial)',
                '[Reformulado M₁V₁ + M₂V₂ = M₃V₃ = M₃(V₁ + V₂)]'
            ],

            plantCountCalculatorDescription: 'Esta calculadora proporciona diseños casi óptimos para plantas rectangulares.',
            growSpaceWidth: 'Ancho del Espacio de Cultivo',
            growSpaceLength: 'Largo del Espacio de Cultivo',
            plantWidth: 'Ancho de la Planta*',
            plantLength: 'Largo de la Planta*',
            gridLayout: 'Diseño de Cuadrícula',
            plantsWideBy: 'plantas de ancho por',
            plantsLong: 'plantas de largo',
            with: 'con',
            plantsInRemainingSpace: 'plantas en espacio restante',
            totalPlants: 'Total de Plantas',
            plants: 'plantas',
            squareFeet: 'ft²',
            usedArea: 'Área Utilizada',
            wastedSpace: 'Espacio Desperdiciado',
            spaceEfficiency: 'Eficiencia del Espacio',
            plantCountSpacingNote: '*Recuerde agregar el espacio adecuado entre plantas, que se cuenta como parte de su tamaño',

            determineSoilAmounts: 'Determinar las cantidades de suelo y enmiendas del suelo, escaladas por maceta.',
            soil1Name: 'Nombre del Suelo 1',
            soil1AmtPerPot: 'Cant. de Suelo 1/Pot',
            soil2Name: 'Nombre del Suelo 2',
            soil2AmtPerPot: 'Cant. de Suelo 2/Pot',
            soil3Name: 'Nombre del Suelo 3',
            soil3AmtPerPot: 'Cant. de Suelo 3/Pot',
            soil4Name: 'Nombre del Suelo 4',
            soil4AmtPerPot: 'Cant. de Suelo 4/Pot',
            soil5Name: 'Nombre del Suelo 5',
            soil5AmtPerPot: 'Cant. de Suelo 5/Pot',
            potCount: 'Conteo de Macetas',
            pots: 'macetas',
            totalSoil: 'Total', // Dynamic label, will replace {medium} with the medium name
            SoilCalcEquations: [
                "Total = Cant. por Maceta * Conteo de Macetas"
            ],

            soilMixRatiosDescription: 'Dado ciertas proporciones de mezcla de suelo, escalar para proporcionar cantidades totales para el número de macetas.',
            potSize: 'Tamaño de la Maceta',

            computeDilutionDescription: 'Calcular la dilución necesaria para alcanzar sólidos disueltos objetivo. Para dilución con agua destilada pura, use TDS Aditivo = 0.00.',
            currentTDS: 'TDS Actual',
            currentVolume: 'Volumen Actual',
            targetTDS: 'TDS Objetivo',
            additiveTDS: 'TDS Aditivo',

            tdsDilutionsEquations: [
                'Volumen Aditivo = ((TDS Objetivo - TDS Actual) * Volumen Actual) / (TDS Aditivo - TDS Objetivo)',
                '[Reformulado C₁V₁ + C₂V₂ = C₃V₃ = C₃(V₁ + V₂)]'
            ],
            convertElementalPPMtoNPK: 'Convertir de nitrógeno, fósforo y potasio como PPM elemental de una solución a porcentajes de masa unidos a la molécula de entrega ("números NPK" en fertilizantes).',
            fertilizerPPMN: 'Fert. PPM N',
            fertilizerPPMP: 'Fert. PPM P',
            fertilizerPPMK: 'Fert. PPM K',
            massPercentageCompositionNote: 'Composición porcentual de masa de NPK elemental en sustancia de entrega molecular NPK; porcentaje dado 0.00 - 1.00 inclusive. Los valores predeterminados asumen elementales presentes como N, P₂O₅, y K₂O.',
            
            nitrogenPercentage: 'N',
            phosphorusPercentage: 'P',
            potassiumPercentage: 'K',
            tdsToNpkEquations: [
                'Porcentaje Elemental = (PPM / 10000) / Porcentaje de Masa',
            ],

            vaporPressureDeficitDescription: 'El déficit de presión de vapor es la diferencia entre el contenido de humedad presente y saturado del aire y afecta la transpiración de las plantas. Para la mayoría de las plantas, un VPD de entre 0.4kPa y 1.25kPa es ideal; las condiciones ideales para el cannabis varían mucho según la fuente, pero generalmente se encuentran alrededor de 0.8kPa a 0.12kPa.',
            airTemperature: 'Temperatura del Aire',
            leafTemperature: 'Temperatura de la Hoja',
            airVPSat: 'VPSat del Aire',
            leafVPSat: 'VPSat de la Hoja',
            naiveVPD: 'VPD Naive',
            leafVPD: 'VPD de la Hoja',
            kPa: 'kPa',

            vaporPressureDeficitEquations: [
                'AirVPSat = 610.78 * e^(tempAmbienteC / (tempAmbienteC + 238.2) * 17.2694) / 1000',
                'LeafVPSat = 610.78 * e^(tempHojaC / (tempHojaC + 238.2) * 17.2694) / 1000',
                'VPD Naive = AirVPSat * (1 - humRelativa / 100)',
                'VPD de la Hoja = LeafVPSat - AirVPSat * humRelativa / 100',
                'Fuente: https://getpulse.co/blog/vpd',
            ],

            computeYieldsDescription: 'Calcular rendimientos teóricos mínimos, promedios y máximos dados un número de plantas.',
            minYieldPerPlant: 'Rend. Mínimo/Planta',
            avgYieldPerPlant: 'Rend. Promedio/Planta',
            maxYieldPerPlant: 'Rend. Máximo/Planta',
            minYield: 'Rendimiento Mínimo',
            avgYield: 'Rendimiento Promedio',
            maxYield: 'Rendimiento Máximo',

            computeYieldsBasedOnHarvestWeights: 'Calcular rendimientos teóricos mínimos, promedios y máximos dados un número de plantas basado en pesos al momento de la cosecha.',
            minWetYieldPerPlant: 'Rend. Húmedo Mínimo/Planta',
            avgWetYieldPerPlant: 'Rend. Húmedo Promedio/Planta',
            maxWetYieldPerPlant: 'Rend. Húmedo Máximo/Planta',
            dryingLoss: 'Pérdida por Secado*',
            dryingLossNote: '*Este porcentaje es la cantidad de materia seca de la planta en comparación con la húmeda -- por ejemplo, 30 gramos secos de 100 gramos húmedos significarían una Pérdida por Secado del 70%. Utilice nuestra calculadora de Cambio de Porcentaje para introducir los valores secos y húmedos esperados para llegar a este número.',

            capsuleCalcEquations: [
                "mL de Cannabinoide en Extracto = Porcentaje de Prueba * Volumen de Concentrado",
                "Porcentaje de Cápsula del Mezcla Total = Volumen de Contenedor / (Volumen de Relleno + Volumen de Concentrado)",
                "Cannabinoide por Cápsula/Cartucho = mL de Cannabinoide en Extracto * Porcentaje de Cápsula del Mezcla Total",
                "",
                "Cannabinoides por Cápsula/Cartucho = Suma de Todos los Cannabinoides por Cápsula/Cartucho",
                "",
                "Cápsulas/Cartuchos Hechos = (Volumen de Relleno + Volumen de Concentrado) / Volumen de Contenedor",
            ],

            capsuleCannabinoidContentCalculation: 'Calcular el contenido de cannabinoides de cápsulas o cartuchos basado en análisis de laboratorio.',
            concentrateVolume: 'Vol. de Concentrado*',
            fillerVolume: 'Vol. de Relleno',
            containerVolume: 'Vol. de Cápsula/Cartucho',
            extractTestResults: 'Resultados de Pruebas de Extracto',
            THC: 'THC',
            THCa: 'THCa',
            delta8THC: 'Δ-8 THC',
            CBD: 'CBD',
            CBN: 'CBN',
            CBG: 'CBG',
            capCartTHC: 'THC de Cápsula/Cartucho*',
            capCartTHCa: 'THCa de Cápsula/Cartucho*',
            capCartDelta8THC: 'Δ-8 THC de Cápsula/Cartucho*',
            capCartCBD: 'CBD de Cápsula/Cartucho*',
            capCartCBN: 'CBN de Cápsula/Cartucho*',
            capCartCBG: 'CBG de Cápsula/Cartucho*',
            capCartTotalCannabinoids: 'Cannabinoides Totales de Cápsula/Cartucho*',
            capsCartsMade: 'Cápsulas/Cartuchos Hechos',
            CapsuleCalcApproximateConversionNote: '*1 mL ≈ 1 g para agua, que puede usarse como una conversión aproximada si el volumen exacto no se conoce. Si se llena por peso, mL se puede leer como mg dondequiera que aparezca la unidad.',

            decarboxylationCalculationDescription: 'Esto determina el tiempo aproximado para decarboxilar completamente material de cannabis seco basado en datos de fuentes científicas (más información en el bloque de ecuaciones). Estos números son una estimación y pueden variar según la potencia, densidad e hidratación de la planta. No hay datos disponibles para temperaturas inferiores a 100°C; los resultados no son confiables por debajo de ese punto.',
            decarbTimeLabel: '~100% Tiempo de Decarb',

            decarbCurveEquations: [
                "Curva de ajuste de potencia determinada a partir de puntos de datos de las siguientes fuentes (identificadas por DOI y autor):",
                "10.1016/j.forsciint.2015.07.019 (Taschwer et. al.)",
                "   180min @ 100°C",
                "   60min @ 150°C",
                "10.1055/s-0031-1298334 (Eichler, et. al.)",
                "   12min @ 140°C",
                "   5min @ 210°C",
                "US7344736B2 (Patente)",
                "   240min @ 105°C",
                "   120min @ 120°C",
                "   60min @ 140°C",
                "",
                "Curva de ajuste de potencia: Tiempo [minutos] = 4e+12 * (Temperatura [°C])^-5.117",
            ],

            decarboxylationDescription: 'Calcular el contenido de cannabinoides de cápsulas o cartuchos basado en análisis de laboratorio.',
            thcaLossTitle: 'Pérdida Solo de THCa',
            thcaLossDescription: 'Al decarboxilar cannabis, la reacción importante es la conversión del ácido tetrahidrocannabinólico (THCa) a tetrahidrocannabinol (THC), el químico realmente psicoactivo. La decarboxilación resulta en la pérdida de un dióxido de carbono, causando una disminución en el peso molecular (358.4733 g/mol - 314.45 g/mol = 44.0233 g/mol de pérdida (~12.22% de pérdida)). Este calculador le permite determinar el THC restante después de la decarboxilación dado los niveles de THCa pre-decarb. Tenga en cuenta que no toma en cuenta la pérdida de peso molar debido a la conversión de CBDA a CBD, CBGA a CBG, etc., que son menos típicamente conocidos para muestras de flores.',
            productTHCaContent: 'Contenido de THCa del Producto',
            postDecarbTHCContent: 'Contenido de THC Post-Decarb',
            productBasedLossTitle: 'Pérdida Basada en Producto',
            productAmount: 'Cantidad de Producto',
            productTHCaPercentage: 'Porcentaje de THCa del Producto',
            preDecarbTHC: 'THC Pre-Decarb',
            postDecarbTHC: 'THC Post-Decarb',
            milligrams: 'mg',
            mgPerGram: 'mg/g',

            decarbLossEquations: [
                "Contenido de THC Post-Decarb = Contenido de THCa del Producto * (314.45 / 358.4733)" 
            ],

            mgPerServingTitle: 'mg/Porción',
            mgPerServingDescription: 'Determinar la potencia de la porción dada la cantidad/potencia del producto utilizada asumiendo una extracción de THC del 100%.',
            productPotency: 'Potencia del Producto',
            servings: 'Porciones',
            decarbCorrectionLabel: 'Corregir por pérdidas de decarboxilación',
            mgTHCPerServing: 'mg THC/porción',
            percentTHC: '% THC',
            EdiblePotencyEquations: [
                "mg THC/porción = (Cantidad de Producto * Potencia del Producto) / Porciones"
            ],

            productAmountTitle: 'Cantidad de Producto',
            productAmountDescription: 'Determinar la cantidad de producto necesaria para una potencia dada asumiendo una extracción de THC del 100%.',
            productNeeded: 'Producto Necesario',
            edibleProductEquations: [
                "THC Necesario = Porciones * mg Por Porción",
                "Producto Necesario = THC Necesario / Potencia del Producto",
            ],

            servingCountTitle: 'Cantidad de Porciones',
            servingCountDescription: 'Determinar la cantidad de porciones dada la potencia de porción deseada y la cantidad/potencia del producto asumiendo una extracción de THC del 100%.',
            servingsOutput: 'Porciones',
            edibleServingEquations: [
                "Porciones = (Cantidad de Producto * Potencia) / mg THC por Porción"
            ],

            solventEvaporationCalculatorDescription: 'Para usar este calculador, mida el peso del solvente que está utilizando antes de introducirlo al cannabis. Después de un tiempo, péselo nuevamente y note el nuevo peso. Estime el rendimiento aproximado del producto que espera como un factor de corrección (o mida el peso del solvente antes y después del contacto con el cannabis para un valor más preciso), y luego este calculador predecirá (asumiendo una tasa de evaporación lineal) el tiempo aproximado que tomará para que el solvente restante se evapore. Tenga en cuenta que esto es muy impreciso y solo debe usarse para estimaciones vagas; la evaporación real del solvente no siempre es lineal.',
            preCannabisSolventWeight: 'Peso del Solvente Pre-cannabis',
            currentSolventWeight: 'Peso Actual del Solvente',
            timeSinceStart: 'Tiempo Desde el Inicio',
            estimatedYield: 'Rendimiento Estimado',
            evaporatedSolvent: 'Solvente Evaporado',
            solventLossPerHour: 'Pérdida de Solvente/hr',
            timeToTotalEvaporation: 'Tiempo para Evaporación Total',

            evapPredictionEquations: [
                "[Peso Actual del Solvente Corregido = Peso Actual del Solvente - Rendimiento Estimado]",
                "Solvente Evaporado = Peso del Solvente Pre-cannabis - Peso Actual del Solvente Corregido",
                "Pérdida de Solvente por Hora = Solvente Evaporado / Tiempo Desde el Inicio",
                "Tiempo para Evaporación Total = Peso Actual del Solvente Corregido / Pérdida de Solvente por Hora"
            ],

            extractionEfficiencyDescription: 'Al hacer extractos, la eficiencia del proceso (cuánto extracto se produce por unidad de materia prima) es importante, pero muy superada por la eficiencia de extracción -- cuánto del THC presente en la materia prima llega al extracto. Por ejemplo, un proceso puede producir menos extracto pero contener una mayor concentración de THC que un proceso diferente ya que extrae más THC y menos residuos (clorofila, etc.) de la planta. La eficiencia de extracción determina el porcentaje de THC extraído, produciendo una métrica más confiable para evaluar los procesos de extracción.',
            feedstockWeight: 'Peso de Materia Prima',
            feedstockTHCContent: 'Contenido de THC de Materia Prima',
            extractWeight: 'Peso del Extracto',
            extractTHCContent: 'Contenido de THC del Extracto',
            weightYield: 'Rendimiento de Peso',
            totalFeedstockTHC: 'THC Total de Materia Prima',
            totalExtractTHC: 'THC Total del Extracto',
            extractionEfficiency: 'Eficiencia de Extracción',
            extractionEfficiencyEquations: [
                "Rendimiento de Peso = Peso del Extracto / Peso de Materia Prima",
                "THC Total de Materia Prima = Contenido de THC de Materia Prima * Peso de Materia Prima",
                "THC Total del Extracto = Contenido de THC del Extracto * Peso del Extracto",
                "Eficiencia de Extracción = THC Total del Extracto / THC Total de Materia Prima",
            ],

            oilButterPotencyTitle: 'Potencia de Aceite/Mantequilla',
            oilButterPotencyDescription: 'Determinar la potencia de un aceite o mantequilla preparados específicamente para una receta asumiendo una extracción de THC del 100%.',
            oilButterInfused: 'Aceite/Mantequilla Infundida',
            oilButterTotalTHC: 'THC Total de Aceite/Mantequilla',
            oilButterTHCPerTablespoon: 'THC de Aceite/Mantequilla por cucharada',
            oilButterTHCPerTeaspoon: 'THC de Aceite/Mantequilla por cucharadita',
            mgPerTablespoon: 'mg/cucharada',
            mgPerTeaspoon: 'mg/cucharadita',

            oilButterPotencyEquations: [
                "THC Total de Aceite = Cantidad de Producto * Potencia",
                "THC de Aceite por cant = THC Total de Aceite / Aceite Infundido",
            ],

            partialOilButterBlendTitle: 'Mezcla Parcial de Aceite/Mantequilla',
            partialOilButterBlendDescription: 'Determinar la mezcla de mantequilla/aceite medicado con mantequilla/aceite regular para recetas con una dosis deseada conocida, pero donde usar solo mantequilla/aceite medicado resultaría en una dosis demasiado potente.',
            medicatedOilPotency: 'Potencia de Aceite Medicado',
            recipeOilCalledFor: 'Aceite Requerido en la Receta',
            desiredServings: 'Porciones Deseadas',
            desiredPotency: 'Potencia Deseada',
            medicatedOilAmount: 'Cantidad de Aceite Medicado',
            regularOilAmount: 'Cantidad de Aceite Regular',
            mgTHCPerTablespoon: 'mg THC/cucharada',
            tablespoons: 'cucharadas',
            mgPerServing: 'mg/porción',

            partialOilButterEquations: [
                "Cantidad de Aceite Medicado = Cantidad de Porciones * THC por Porción / Potencia del Aceite Medicado",
                "Aceite Regular = Cantidad Total de Aceite Necesario - Cantidad de Aceite Medicado"
            ],

            additiveAmountCalculationDescription: 'Esto resuelve la cantidad de aditivo en casos donde el aditivo puede ser, como máximo, un porcentaje dado de la constitución final (por ejemplo, muchos aditivos de terpeno recomiendan no más del 5% de la constitución final de la mezcla; dado 200g de concentrado, por lo tanto, se pueden añadir 10.526g de terpenos).',
            startAmount: 'Cantidad Inicial',
            finalPercentageOfAdditive: 'Porcentaje Final del Aditivo',
            additiveAmountOutput: 'Cantidad de Aditivo',
            totalAmountOutput: 'Cantidad Total',
            percentConstituentEquations: [
                "Cantidad Total = Cantidad Inicial / (100 - Porcentaje Final del Aditivo)",
                "Cantidad de Aditivo = Cantidad Total - Cantidad Inicial"
            ],

            knownIngredientsTitle: 'Ingredientes Conocidos',
            knownIngredientsDescription: 'Determinar la cantidad y potencia de un producto final dado los insumos conocidos.',
            product1: 'Producto 1',
            product2: 'Producto 2',
            product3: 'Producto 3',
            product4: 'Producto 4',
            thc: 'THC',
            cbd: 'CBD',
            finalProduct: 'Producto Final',
            totalTHC: 'THC Total',
            totalCBD: 'CBD Total',
            thcToCbdRatio: 'Relación: 1THC a',
            percentCBD: '% CBD',
            cbdUnit: 'CBD',

            saladGeneratorTitle: 'Generador de Ensaladas',
            saladGeneratorDescription: 'Determinar la mezcla de opciones que se aproximen más a la relación deseada.',
            oneTHCTo: '1 THC a',
            maxElements: 'Máx. Elementos',
            minimumTHC: 'THC Mín.',
            productLabel: 'Producto',
            thcPercentage: '% THC',
            cbdPercentage: '% CBD',
            grams: 'g',
            cantMakeBlend: "¡No se puede hacer esa mezcla!",

            thcPotencycalculatorSectionDescription: 'Elija la sección de calculadora apropiada para sus unidades. mg y g se utilizan como unidades de analito estándar; si sus valores iniciales están en una unidad diferente, use nuestra calculadora de Conversión de Peso.',
            percentageTHC: 'Porcentaje de THC',
            mgTHCPerGram: 'mg THC por Gramo',
            mgTHCPerGramInput: 'mg THC/gramo',
            percentageTHCOutput: 'Porcentaje de THC',
            productVolume: 'Volumen del Producto',
            productDensity: 'Densidad del Producto',
            mgMLTHC: 'mg/mL THC',
            mgGTHC: 'mg/g THC',
            thcPercentageOutput: 'Porcentaje de THC',
            productWeight: 'Peso del Producto',
            mgTHCPerGramOutput: 'mg THC por Gramo',
            milliliters: 'mL',
            gramsPerMilliliter: 'g/mL',

            variableServingPotencyTitle: 'Receta Completa (Flores, Volumen)',
            variableServingPotencyDescription: 'Determinar la porción y la desglose de potencia de un aceite o mantequilla preparada específicamente para una receta asumiendo una extracción de THC del 100%.',
            bakedGoodOilAmount: 'Cantidad de Aceite para Repostería',
            bakedGoodServings: 'Porciones de Repostería',
            bakedGoodTotalTHC: 'THC Total de Repostería',
            thcPerServing: 'THC/Porción',
            variableServingPotencyVolumeNote: '*Este porcentaje es la cantidad de materia vegetal seca en comparación con la húmeda -- por ejemplo, 30 gramos secos de 100 gramos húmedos significarían una Pérdida por Secado del 70%. Utilice nuestra calculadora de Cambio de Porcentaje para introducir los valores secos y húmedos esperados para llegar a este número.',
            variableServingPotencyVolumeEquations: [
                "THC Total del Aceite = Cantidad de Producto * Potencia",
                "THC por cucharada de Aceite = THC Total del Aceite / Aceite Infundido",
                "THC Total de la Repostería = THC por cucharada de Aceite * Cantidad de Aceite para Repostería (en cucharadas)",
                "THC por Porción = THC Total de la Repostería / Porciones"
            ],

            completeRecipeOilButterVolumeTitle: 'Receta Completa (Aceite/Mantequilla, Volumen)',
            completeRecipeOilButterVolumeDescription: 'Determinar la porción y desglose de potencia de un comestible hecho con un aceite/mantequilla medicado conocido.',
            oilButterPotency: 'Potencia de Aceite/Mantequilla',
            mgPerCup: 'mg/taza',
            variableServPotenVolumeButteEquations: [
                "THC Total de Repostería = THC por cantidad de Aceite * Cantidad de Aceite para Repostería",
                "THC por Porción = THC Total de Repostería / Porciones"
            ],

            completeRecipeFlowersWeightTitle: 'Receta Completa (Flores, Peso)',
            completeRecipeFlowersWeightDescription: 'Determinar la porción y desglose de potencia de un aceite o mantequilla preparada específicamente para una receta asumiendo una extracción de THC del 100%.',
            
            oilButterInfusedWeight: 'Aceite/Mantequilla Infundida',
            bakedGoodOilAmountWeight: 'Cantidad de Aceite para Repostería',
            oilButterTHCPerGram: 'THC de Aceite/Mantequilla/gramo',
            variableServPotencyWeightEquations: [
                "THC Total del Aceite = Cantidad de Producto * Potencia",
                "THC por gramo de Aceite = THC Total del Aceite / Aceite Infundido",
                "THC Total de la Repostería = THC por gramo de Aceite * Cantidad de Aceite para Repostería (en cucharadas)",
                "THC por Porción = THC Total de la Repostería / Porciones"
            ]

        },  //end of es

        //german
        de:{
            headings: {
                generalCannabisGrowingCalculators: 'Allgemeine Cannabis-Anbau-Rechner & Umrechnungen',
                WeightConversion: 'Gewichtsumrechnung',
                DistanceConversion: 'Entfernungsumrechnung',
                TemperatureConversion: 'Temperaturumrechnung',
                SpeedConversion: 'Geschwindigkeitsumrechnung',
                AreaConversion: 'Flächenumrechnung',
                VolumeConversion: 'Volumenumrechnung',
                FlowRateConversion: 'Durchflussraten-Umrechnung',
                TimeConversion: 'Zeitumrechnung',
                DateCalculator: 'Datumsrechner',
                ECTDSConversion: 'EC/TDS-Umrechnung',
                TrimmingTimePredictionCalculator: 'Berechnung der Beschnittzeit-Vorhersage',
                PercentageCalculator: 'Prozentrechner',
                CylinderDuctingVolume: 'Zylinder (Lüftungs-) Volumen',
                CannabisLightingPowerWaterCalculators: 'Cannabis Beleuchtungs-/Strom-/Wasserrechner',
                LightWattageLumens: 'Licht Wattzahl/Lumen',
                DeliveredLumens: 'Abgegebene Lumen',
                BTUsGeneratedHeatOffsetCalculator: 'Erzeugte BTUs/Hitzeausgleich-Rechner',
                CO2FlowRate: 'CO₂ Durchflussrate',
                ExhaustCFMCalculator: 'Abgas-CFM-Rechner',
                LightKWhCost: 'Licht kWh & Kosten',
                WaterUsageDripTipFlowCost: 'Wasserverbrauch/Tropfspitzenfluss & Kosten',
                TimeLapseImageSize: 'Zeitrafferbildgröße',
                CannabisGrowingFertilizerAgricultureCalculators: 'Cannabis-Anbau/Dünger/Landwirtschaftsrechner',
                DewPoint: 'Taupunkt',
                VaporPressureDeficitCalculator: 'Dampfdruckdefizit-Rechner (VPD)',
                ProjectedGrowthTimelineCalendar: 'Projizierter Wachstumszeitplan/Kalender',
                PlantLayout: 'Pflanzenanordnung',
                SoilAmountToTotal: 'Bodenmenge zur Gesamtmenge',
                SoilRatioToTotal: 'Bodenverhältnis zur Gesamtmenge',
                PHWaterAdjustment: 'pH/Wasseranpassung',
                NPKToPPMTDS: 'NPK zu PPM TDS',
                PPMTDSToNPM: 'PPM TDS zu NPM',
                DilutionToTDSTarget: 'Verdünnung zum TDS-Ziel',
                GeneralCropYield: 'Allgemeiner Ernteertrag',
                DryWetYield: 'Trocken-/Nassertrag',
                EdibleCalculatorsConcentratesBlending: 'Essbare Rechner, Konzentrate und Mischung',
                EdiblePotency: 'Essbare Potenz',
                OilButterPotency: 'Öl-/Butterpotenz',
                THCPotencyConversions: 'THC/Potenz-Umrechnungen',
                SaladsBlending: 'Salate & Mischung',
                DecarboxylationLoss: 'Decarboxylierungsverlust',
                DecarboxylationCurvePrediction: 'Decarboxylierungskurven-Prognose',
                ExtractionEfficiency: 'Extraktionseffizienz',
                SolventEvaporationTimeEstimate: 'Lösungsmittelverdunstungszeit-Schätzung',
                ConcentrateToCapsuleTHCBreakdown: 'Konzentrat zu Kapsel THC-Aufschlüsselung',
                MaxPercentConstituentTerpeneAddition: 'Max. Prozentanteil (Terpenzusatz)'
            },
            Equations: 'Gleichungen',
            minusSign: '-',
            plusSign: '+',
            whenSplit: 'bei Aufteilung',
            ways: 'Möglichkeiten',
            examplePerPlantOrPerRoom: 'z.B. pro Pflanze oder pro Raum',
            Area: 'Fläche',
            CylinderCalcDescription: '*Wenn das Zylindervolumen verwendet wird, um das Gesamtvolumen der Belüftung zu bestimmen, verwenden Sie die Gesamtlänge der Belüftung als Höhe.',
            Radius: 'Radius',
            Height: 'Höhe',
            Volume: 'Volumen',
            units3: 'Einheiten³',
            StartDate: 'Startdatum (JJJJ-MM-TT)',
            StartTime: 'Startzeit (HH:MM:SS)',
            Add: 'Hinzufügen',
            Subtract: 'Subtrahieren',
            Years: 'Jahre',
            Months: 'Monate',
            Days: 'Tage',
            Hours: 'Stunden',
            Minutes: 'Minuten',
            Seconds: 'Sekunden',
            AdjustedDate: 'Angepasstes Datum',
            AdjustedTime: 'Angepasste Zeit',
            InvalidInput: 'Ungültige Eingabe',
            dateCalcDesc: 'Daten von einem bestimmten Startdatum hinzufügen oder subtrahieren',
            Distance: 'Entfernung',
            EC_TDS: 'EC/TDS',
            FlowRate: 'Durchflussrate',
            Input: 'Eingabe',
            Output: 'Ausgabe',
        
            determineIllumination: 'Notwendige Beleuchtung für einen bestimmten Bereich bestimmen.',
            desiredLumens: 'Gewünschte Lumen*',
            desiredWatts: 'Gewünschte Watt',
            growAreaWidth: 'Breite des Anbaubereichs',
            growAreaLength: 'Länge des Anbaubereichs',
            illuminationNeeded: 'Benötigte Beleuchtung',
            wattsNeeded: 'Benötigte Watt',
            lumensWattsNote: '*Obwohl Lumen ein präziseres Maß für die tatsächliche Lichtleistung sind, sind Watt zu einem de facto Standard geworden -- bei Zweifeln verwenden Sie Watt und ignorieren Sie Lumen.',
            lightingEquations: [
                'Benötigte Beleuchtung = Breite des Anbaubereichs * Länge des Anbaubereichs * Gewünschte Lumen',
                'Benötigte Watt = Breite des Anbaubereichs * Länge des Anbaubereichs * Gewünschte Wattzahl',
            ],
            lumens: 'Lumen',
            watts: 'Watt',
        
            linearCalculatorExplanation: 'Dieser Rechner verallgemeinert jede lineare Aufgabe (d.h., wenn es eine Stunde dauert, zwei zu erledigen, dauert es zwei Stunden für vier und drei Stunden für sechs usw.).',
            amountDone: 'Erledigte Menge',
            timeTakenSoFar: 'Bisher benötigte Zeit',
            amountLeft: 'Verbleibende Menge',
            workPace: 'Arbeitstempo',
            timeToCompletion: 'Zeit bis zur Fertigstellung',
            units: 'Einheiten',
            units_hr: 'Einheiten/Stunde',
            linearCalcEquations: [
                'Arbeitstempo = Erledigte Menge / Bisher benötigte Zeit',
                'Zeit bis zur Fertigstellung = Verbleibende Menge / Arbeitstempo'
            ],

            before: 'Vorher',
            after: 'Nachher',
            change: 'Änderung',

            Speed: 'Geschwindigkeit',
            Temperature: 'Temperatur',

            Time: 'Zeit',
            Weight: 'Gewicht',

            determineLumens: 'Bestimmen Sie die Lumen pro Fläche, die von gegebenen Lichtern geliefert werden.',
            roomArea: 'Raumfläche',
            light1Lumens: 'Licht 1 Lumen',
            light1Count: 'Licht 1 Anzahl',
            light2Lumens: 'Licht 2 Lumen',
            light2Count: 'Licht 2 Anzahl',
            light3Lumens: 'Licht 3 Lumen',
            light3Count: 'Licht 3 Anzahl',
            light4Lumens: 'Licht 4 Lumen',
            light4Count: 'Licht 4 Anzahl',
            roomAreaOutput: 'Raumfläche',
            totalIllumination: 'Gesamtbeleuchtung',
            illuminationPerFtSq: 'Beleuchtung pro Quadratfuß',
            lights: 'Lichter',
            ftSq: 'Quadratfuß',
            lumensPerFtSq: 'Lumen/Quadratfuß',
            DeliveredLightingEquations: [
                'Gesamtbeleuchtung = Summe(Licht X Anzahl * Licht X Lumen)',
                'Beleuchtung pro Fläche = Gesamtbeleuchtung / Fläche',
            ],

            ampCalcImportantNote: 'Wichtige Anmerkung:',
            wattageExplanation: 'die hier erwähnte Wattzahl bezieht sich nicht auf die Lichtleistungswattzahl (d.h., wie hell die Lichter sind). Dies ist die Wattzahl im wahren Sinne der von den Lichtern verbrauchten Leistung. Diese Information findet sich in der Regel im Datenblatt Ihrer Lichter. Wenn keine Wattzahl gefunden wird, können Sie sie berechnen, indem Sie die von den Lichtern verbrauchte Stromstärke mit der Spannung multiplizieren (in den USA in der Regel 120). Zum Beispiel würde ein Licht, das 5 Ampere Leistung verbraucht, 600 Watt verbrauchen (5 Ampere * 120 Volt).',
            monthAssumption: 'Monat geht von 31 Tagen aus.',
            singleLightWattage: 'Einzelne Lichtwattzahl',
            voltage: 'Spannung',
            dollarCostPerKWh: 'Dollar Kosten pro kWh',
            hoursOnPerDay: 'Stunden pro Tag eingeschaltet',
            lightCount: 'Lichtanzahl',
            totalAmperage: 'Gesamtstromstärke',
            powerPerDay: 'Leistung pro Tag',
            costPerDay: 'Kosten/Tag',
            powerPerMonth: 'Leistung pro Monat',
            costPerMonth: 'Kosten/Monat',
            volts: 'Volt',
            dollars: 'Dollar',
            hours: 'Stunden',
            amps: 'Ampere',
            kWhPerDay: 'kWh/Tag',
            dollarSign: '$',
            kWhPerMonth: 'kWh/Monat',
            ampCalcEquations: [
                'Gesamtstromstärke = Einzelne Lichtwattzahl / Spannung * Lichtanzahl',
                'Leistung pro Tag (kW) = Einzelne Lichtwattzahl * Stunden pro Tag eingeschaltet * Lichtanzahl / 1000',
                'Kosten pro Tag = Leistung pro Tag * Dollar Kosten pro kWh',
                'Leistung pro Monat = Leistung pro Tag * 31',
                'Kosten pro Monat = Leistung pro Monat * Dollar Kosten pro kWh',
            ],

            BtuImportantNote: 'Wichtige Anmerkung:',
            BtuWattageExplanation: 'die hier erwähnte Wattzahl bezieht sich nicht auf die Lichtleistungswattzahl (d.h. wie hell die Lichter sind). Dies ist die Wattzahl im wahren Sinne der von den Lichtern verbrauchten Leistung. Diese Information findet sich in der Regel im Datenblatt Ihrer Lichter. Wenn keine Wattzahl gefunden wird, können Sie sie berechnen, indem Sie die von den Lichtern verbrauchte Stromstärke mit der Spannung multiplizieren (in den USA in der Regel 120). Zum Beispiel würde ein Licht, das 5 Ampere Leistung verbraucht, 600 Watt verbrauchen (5 Ampere * 120 Volt).',
            btuCalculationAssumption: 'BTU-Berechnungen gehen von 3.412 BTUs/Watt aus',
            co2GeneratorBTUs: 'CO₂ Generator BTUs',
            co2Generators: 'CO₂ Generatoren',
            dehumidifierWattage: 'Entfeuchter Wattzahl',
            dehumidifiers: 'Entfeuchter',
            btusPerHour: 'BTUs/Stunde',
            btus: 'BTUs',
            generators: 'Generatoren',
            BtcCalcEquations: [
                'BTUs pro Watt = 3.4.12',
                'Gesamte Lichtwattzahl = Einzelne Lichtwattzahl * Lichtanzahl',
                'Gesamte CO₂ BTUs = CO₂ Generator BTUs * CO₂ Generator Anzahl',
                'Gesamte Entfeuchter Wattzahl = Entfeuchter Wattzahl * Entfeuchter Anzahl',
                'BTUs pro Stunde = (Gesamte Lichtwattzahl + Gesamte Entfeuchter Wattzahl) * BTUs pro Watt + Gesamte CO₂ BTUs',
            ],

            determineCO2FlowRate: 'Bestimmen Sie die notwendige CO₂-Flussrate für die CO₂-Ergänzung zur gewünschten Konzentration.',
            co2SafetyNote: 'CO₂ ist ein Erstickungsmittel und kann töten. Üben Sie immer die richtige Sicherheit aus, wenn Sie CO₂ und CO₂-Erzeugungsausrüstung verwenden.',
            roomWidth: 'Raumbreite',
            roomLength: 'Raumlänge',
            roomHeight: 'Raumhöhe',
            volumeCompensation: 'Volumenkompensation',
            ambientCO2: 'Umgebungs-CO₂',
            desiredCO2: 'Gewünschtes CO₂',
            minutesOn: 'Minuten eingeschaltet',
            roomVolume: 'Raumvolumen',
            desiredAdditionalCO2: 'Gewünschtes zusätzliches CO₂',
            fixedAdditionalCO2: 'Festgelegtes zusätzliches CO₂',
            co2FlowRatePerHour: 'CO₂-Flussrate (pro Stunde)',
            co2FlowRatePerMinute: 'CO₂-Flussrate (pro Minute)',
            ppm: 'ppm',
            minutes: 'Minuten',
            ftCubed: 'Kubikfuß',
            ftCubedPerHour: 'Kubikfuß/Stunde',
            scfh: 'SCFH (Kubikfuß/Stunde)',
            scfm: 'SCFM (Kubikfuß/Minute)',
            Co2RoomVolumeNote: '*Das Raumvolumen berücksichtigt keinen Platz, der von Leitungen, Ventilatoren, Pflanzenhaltern usw. eingenommen wird. -- Geben Sie hier das ungefähre Volumen ein, das von Objekten im Raum eingenommen wird, um die Volumengenauigkeit zu erhöhen. Für Leitungen verwenden Sie den Zylindervolumenrechner mit der Länge der Leitung als Zylinderhöhe.',
            co2CalcEquations: [
                'Raumvolumen = Breite * Länge * Höhe - Volumenausgleich',
                'Gewünschtes zusätzliches CO₂ = Gewünschtes CO₂ - Umgebungs-CO₂',
                'Festgelegtes zusätzliches CO₂ = (Gewünschtes zusätzliches CO₂ * 1e-6) * Raumvolumen',
                'CO₂-Flussrate = Festgelegte CO₂-Flussrate / (Minuten an / 60)',
            ],

            airflowNote: 'Beachten Sie, dass dies nur für reinen Luftstrom gilt; dies berücksichtigt keinen Druckverlust durch Biegungen in Leitungen, Staub usw., der stark von der Leitung und dem Layout abhängt.',
            fanCount: 'Ventilatorenanzahl',
            exchangeTime: 'Austauschzeit',
            compensationFactorNote: 'Einige Seiten empfehlen, einen Kompensationsfaktor für hitzeintensive oder luftstromresistente Quellen wie HID-Leuchten und Kohlefilter hinzuzufügen. Sie können hier bei Bedarf die Korrektur und die Anzahl solcher Geräte angeben; das Raumvolumen wird um den angegebenen Prozentsatz für jedes Gerät angepasst. Häufige Faktoren wurden bereitgestellt.',
            carbonFilterCount: 'Anzahl Kohlefilter',
            carbonFilterCorrection: 'Korrektur für Kohlefilter',
            oneKWHIDLightCount: 'Anzahl 1kW HID-Leuchten',
            oneKWHIDLightCorrection: 'Korrektur für 1kW HID-Leuchten',
            roomVolumeCorrected: 'Raumvolumen*',
            minTotalFlow: 'Min. Gesamtfluss',
            minFanFlowEach: 'Min. Fluss pro Ventilator',
            correctedForFiltersOrHIDLamps: '*Korrigiert für gegebene Filter oder HID-Lampen',
            fans: 'Ventilatoren',
            minutesTotalAirFlush: 'Minuten bis zur vollständigen Luftspülung',
            filters: 'Filter',
            percent: '%',
            exhaustCalcEquations: [
                'Raumvolumen = (Breite * Länge * Höhe) + (Anzahl Kohlefilter * Korrektur für Kohlefilter) + (Anzahl HID-Leuchten * Korrektur für HID-Leuchten)',
                'Min. Gesamtfluss = Raumvolumen / Austauschzeit',
                'Min. Fluss pro Ventilator = Min. Gesamtfluss / Ventilatorenanzahl',
            ],

            imageFrequencyToSize: 'Bildfrequenz zu Größe',
            storageSpaceNote: 'Bestimmen Sie den benötigten Speicherplatz für eine gegebene Bildrate. Monat geht von 31 Tagen aus.',
            imageSize: 'Bildgröße',
            captureInterval: 'Aufnahmeintervall',
            sizePerDay: 'Größe pro Tag',
            sizePerWeek: 'Größe pro Woche',
            sizePerMonth: 'Größe pro Monat',
            sizePerFourMonths: 'Größe pro 4 Monate',
            mb: 'MB',

            captureIntervalFromSpaceRestriction: 'Aufnahmeintervall aufgrund von Speicherplatzbeschränkungen',
            determineFastestCaptureInterval: 'Bestimmen Sie das schnellstmögliche Aufnahmeintervall bei begrenztem Speicherplatz.',
            storageSpace: 'Speicherplatz',
            totalLapseTime: 'Gesamte Zeitrafferzeit',
            fastestInterval: 'Schnellstes Intervall',
            gb: 'GB',
            days: 'Tage',

            weightConvCalcEquations: [
                'Pro Tag verwendete Wassermenge = Wasserrate pro Pflanze * Stunden pro Tag eingeschaltet * Pflanzenanzahl',
                'Kosten pro Tag = Pro Tag verwendete Wassermenge * Wasserkosten',
                'Pro Monat verwendete Wassermenge = Pro Tag verwendete Wassermenge * 31',
                'Kosten pro Monat = Pro Monat verwendete Wassermenge * Wasserkosten',
            ],
            determineWaterUsageAndCost: 'Bestimmen Sie Wasserverbrauch und -kosten für eine gegebene Anzahl von Pflanzen und Durchflussrate',
            equationWaterUsedPerDay: 'Pro Tag verwendete Wassermenge = Wasserrate pro Pflanze * Stunden pro Tag eingeschaltet * Pflanzenanzahl',
            equationCostPerDay: 'Kosten pro Tag = Pro Tag verwendete Wassermenge * Wasserkosten',
            equationWaterUsedPerMonth: 'Pro Monat verwendete Wassermenge = Pro Tag verwendete Wassermenge * 31',
            equationCostPerMonth: 'Kosten pro Monat = Pro Monat verwendete Wassermenge * Wasserkosten',
            waterRatePerPlant: 'Wasserrate pro Pflanze',
            plantCount: 'Pflanzenanzahl',
            waterCost: 'Wasserkosten',
            gph: 'Galonen/Stunde (GPH)',
            dollarsPerCubicFoot: 'Dollar pro Kubikfuß',
            waterUsedPerDay: 'Pro Tag verwendete Wassermenge',
            waterUsedPerMonth: 'Pro Monat verwendete Wassermenge*',
            gallonsPerDay: 'Galonen/Tag',
            gallonsPerMonth: 'Galonen/Monat',

            determineDewPoint: 'Taupunkt bestimmen.',
            temperature: 'Temperatur',
            relativeHumidity: 'Rel. Luftfeuchtigkeit',
            dewPoint: 'Taupunkt',
            dewPointEquations: [
                'Magnus-Formel:',
                'Taupunktkonstanten sind a = 6.112 mb, b = 17.67, c = 243.5 °C (Bolton/Monatswetter)',
                '[VaporPressureHelperValue = ln(RelLuftf. / 100) + ((b * Temp) / (c + Temp))]',
                'Tau-/Frostpunkt = (c * VaporPressureHelperValue) / (b - VaporPressureHelperValue)',
            ],

            determinePlantCalendarDates: 'Bestimmen Sie Kalenderdaten für wichtige Zeiten im Leben Ihrer Pflanzen',
            plantDate: 'Pflanzdatum (JJJJ-MM-TT)',
            daysToSprout: 'Tage bis zum Keimen',
            daysVegetative: 'Tage Vegetativ',
            daysFlowering: 'Tage Blüte',
            daysDrying: 'Tage Trocknung',
            daysCuring: 'Tage Aushärten',
            daysProcessing: 'Tage Verarbeitung',
            sprouted: 'Gekeimt',
            floweringBegins: 'Blüte beginnt',
            harvest: 'Ernte',
            doneDrying: 'Trocknung beendet',
            doneCuring: 'Aushärten beendet',
            doneProcessing: 'Verarbeitung beendet',

            convertNPKtoPPMDesc: 'Umwandlung von gebundenem Stickstoff, Phosphor und Kalium in Prozentwerten ("NPK"-Werte auf Dünger) zu PPM TDS bei einem gegebenen Verdünnungsverhältnis.',
            fertilizerN: 'Dünger N',
            fertilizerP: 'Dünger P',
            fertilizerK: 'Dünger K',
            addedAmount: 'Hinzugefügte Menge',
            sgOverride: 'S.G. Überschreibung*',
            sgOverrideNote: '*In Fällen einer %w/v-Lösung, geben Sie das spezifische Gewicht des Düngers ein, um Nicht-1,0-S.G.-Umwandlungen zu korrigieren.',
            npkMassPercentageNote: 'Massenprozentzusammensetzung von elementarem NPK in molekularem NPK-Lieferstoff; Prozentwerte zwischen 0,00 und 1,00 einschließlich. Voreinstellungen nehmen Elemente als N, P₂O₅ und K₂O an.',
            nMassFraction: 'N-Massenanteil',
            pMassFraction: 'P-Massenanteil',
            kMassFraction: 'K-Massenanteil',
            dilutedN: 'Verdünntes N',
            dilutedP: 'Verdünntes P',
            dilutedK: 'Verdünntes K',
            totalDiluted: 'Gesamt Verdünnt',
            ppmTDS: 'PPM TDS',
            unitEmpty: '',
            mlPerLiter: 'ml Düng./Liter H₂O',
            NpkToTdsEquations: [
                '[Prozent Mischung = Hinzugefügte Menge / 1000]',
                '[Endprozent = Prozent Mischung * Dünger N]',
                '[End-PPM = Endprozent * 10000]',
                'Verdünntes Element = End-PPM * Massenprozent * S.G. Überschreibung',
            ],

            adjustPhDescription: 'pH-Wert der Lösung mit einem bekannten Additiv-pH nach oben oder unten anpassen. Einige gängige Additiv-pH-Werte:',
            startPh: 'Start pH',
            startVolume: 'Startvolumen',
            desiredPh: 'Gewünschter pH',
            additivePh: 'Additiv pH',
            startMolarity: 'Start Mol.',
            additiveMolarity: 'Additiv Mol.',
            desiredMolarity: 'Gewünschte Mol.',
            additiveVolume: 'Additiv Vol.',
            micromoles: 'µmol',
            phConvEquations: [
                'Start Mol. = 10e-[Start pH] / 1e-6',
                'Additiv Mol. = 10e-[Additiv pH] / 1e-6',
                'Gewünschte Mol. = 10e-[Gewünschter pH] / 1e-6',
                'Additiv Vol. = ((Gewünschte Mol. - Start Mol.) * Startvolumen) / (Additiv Mol. - Start Mol.)',
                '[Umformatierte M₁V₁ + M₂V₂ = M₃V₃ = M₃(V₁ + V₂)]',
            ],

            plantCountCalculatorDescription: 'Dieser Rechner liefert nahezu optimale Layouts für rechteckige Pflanzen.',
            growSpaceWidth: 'Breite des Anbauraums',
            growSpaceLength: 'Länge des Anbauraums',
            plantWidth: 'Pflanzenbreite*',
            plantLength: 'Pflanzenlänge*',
            gridLayout: 'Rasterlayout',
            plantsWideBy: 'Pflanzen breit mal',
            plantsLong: 'Pflanzen lang',
            with: 'mit',
            plantsInRemainingSpace: 'Pflanzen im verbleibenden Raum',
            totalPlants: 'Gesamtzahl der Pflanzen',
            plants: 'Pflanzen',
            squareFeet: 'ft²',
            usedArea: 'Genutzte Fläche',
            wastedSpace: 'Verschwendeter Raum',
            spaceEfficiency: 'Raumeffizienz',
            plantCountSpacingNote: '*Denken Sie daran, den geeigneten Abstand zwischen den Pflanzen hinzuzufügen, der als Teil ihrer Größe gezählt wird',

            determineSoilAmounts: 'Bestimmen Sie die Mengen an Erde und Bodenverbesserungsmitteln, hochgerechnet pro Topf.',
            soil1Name: 'Erde 1 Name',
            soil1AmtPerPot: 'Erde 1 Menge/Topf',
            soil2Name: 'Erde 2 Name',
            soil2AmtPerPot: 'Erde 2 Menge/Topf',
            soil3Name: 'Erde 3 Name',
            soil3AmtPerPot: 'Erde 3 Menge/Topf',
            soil4Name: 'Erde 4 Name',
            soil4AmtPerPot: 'Erde 4 Menge/Topf',
            soil5Name: 'Erde 5 Name',
            soil5AmtPerPot: 'Erde 5 Menge/Topf',
            potCount: 'Topfanzahl',
            pots: 'Töpfe',
            totalSoil: 'Gesamt', // Dynamisches Label, ersetzt {medium} durch den Namen des Mediums
            SoilCalcEquations: [
                "Gesamt = Menge pro Topf * Topfanzahl", 
            ],

            soilMixRatiosDescription: 'Bei bestimmten Verhältnissen von Bodenmischungen, hochrechnen, um Gesamtmengen für die Anzahl der Töpfe bereitzustellen.',
            potSize: 'Topfgröße',

            computeDilutionDescription: 'Berechnen Sie die benötigte Verdünnung, um Zielgelöste Feststoffe zu erreichen. Für Verdünnung mit reinem destilliertem Wasser verwenden Sie Additiv TDS = 0,00.',
            currentTDS: 'Aktuelle TDS',
            currentVolume: 'Aktuelles Volumen',
            targetTDS: 'Ziel-TDS',
            additiveTDS: 'Additiv TDS',
            tdsDilutionsEquations: [
                'Zusatzvolumen = ((Ziel-TDS - Aktuelle TDS) * Aktuelles Volumen) / (Zusatz-TDS - Ziel-TDS)',
                '[Umformatiert C₁V₁ + C₂V₂ = C₃V₃ = C₃(V₁ + V₂)]',
            ],
        
            convertElementalPPMtoNPK: 'Umwandlung von Stickstoff, Phosphor und Kalium als elementare PPM einer Lösung in massenprozentuale Bindungsmoleküle ("NPK"-Zahlen auf Dünger).',
            fertilizerPPMN: 'Dünger PPM N',
            fertilizerPPMP: 'Dünger PPM P',
            fertilizerPPMK: 'Dünger PPM K',
            massPercentageCompositionNote: 'Massenprozentzusammensetzung von elementarem NPK in molekularem NPK-Lieferstoff; Prozentwerte zwischen 0,00 und 1,00 einschließlich. Voreinstellungen nehmen Elemente als N, P₂O₅ und K₂O an.',
            
            nitrogenPercentage: 'Stickstoffanteil',
            phosphorusPercentage: 'Phosphoranteil',
            potassiumPercentage: 'Kaliumanteil',
            tdsToNpkEquations: [
                'Elementprozentsatz = (PPM / 10000) / Massenprozent',
            ],
        
            vaporPressureDeficitDescription: 'Das Dampfdruckdefizit ist die Differenz zwischen dem gegenwärtigen und gesättigten Feuchtigkeitsgehalt der Luft und beeinflusst die Pflanzentranspiration. Für die meisten Pflanzen ist ein VPD zwischen 0,4 kPa und 1,25 kPa ideal; ideale Bedingungen für Cannabis variieren je nach Quelle, liegen aber im Allgemeinen bei etwa 0,8 kPa bis 0,12 kPa.',
            airTemperature: 'Lufttemperatur',
            leafTemperature: 'Blattemperatur',
            airVPSat: 'Luft VPSat',
            leafVPSat: 'Blatt VPSat',
            naiveVPD: 'Naives VPD',
            leafVPD: 'Blatt VPD',
            kPa: 'kPa',
        
            vaporPressureDeficitEquations: [
                'LuftVPSat = 610,78 * e^(RaumtemperaturC / (RaumtemperaturC + 238,2) * 17,2694) / 1000',
                'BlattVPSat = 610,78 * e^(BlattemperaturC / (BlattemperaturC + 238,2) * 17,2694) / 1000',
                'Naives VPD = LuftVPSat * (1 - rel. Luftfeuchtigkeit / 100)',
                'Blatt VPD = BlattVPSat - LuftVPSat * rel. Luftfeuchtigkeit / 100',
                'Quelle: https://getpulse.co/blog/vpd',
            ],
        
            computeYieldsDescription: 'Berechnen Sie min., durchschn. und max. theoretische Erträge für eine Anzahl von Pflanzen.',
            minYieldPerPlant: 'Min. Ertrag/Pflanze',
            avgYieldPerPlant: 'Durchschn. Ertrag/Pflanze',
            maxYieldPerPlant: 'Max. Ertrag/Pflanze',
            minYield: 'Min. Ertrag',
            avgYield: 'Durchschn. Ertrag',
            maxYield: 'Max. Ertrag',
        
            computeYieldsBasedOnHarvestWeights: 'Berechnen Sie min., durchschn. und max. theoretische Erträge für eine Anzahl von Pflanzen basierend auf Erntezeit-Gewichten.',
            minWetYieldPerPlant: 'Min. Nassertrag/Pflanze',
            avgWetYieldPerPlant: 'Durchschn. Nassertrag/Pflanze',
            maxWetYieldPerPlant: 'Max. Nassertrag/Pflanze',
            dryingLoss: 'Trocknungsverlust*',
            dryingLossNote: '*Dieser Prozentsatz ist die Menge an trockener Pflanzenmasse im Vergleich zu nasser -- z.B. 30 Gramm trocken von 100 Gramm nass würde einen 70% Trocknungsverlust bedeuten. Verwenden Sie unseren Prozentänderungsrechner, um erwartete trockene und nasse Werte einzugeben und diese Zahl zu ermitteln.',
        
            capsuleCalcEquations: [
                "mL Cannabinoid im Extrakt = Testprozentsatz * Konzentratvolumen",
                "Kapselprozentsatz des Gesamtmixes = Behältervolumen / (Füllvolumen + Konzentratvolumen)",
                "Cannabinoid pro Kap./Kart. = mL Cannabinoid im Extrakt * Kapselprozentsatz des Gesamtmixes",
                "",
                "Kap./Kart. Cannabinoide = Summe aller Cannabinoide pro Kap./Kart.",
                "",
                "Kapseln/Kartuschen hergestellt = (Füllvolumen + Konzentratvolumen) / Behältervolumen",
            ],
        
            capsuleCannabinoidContentCalculation: 'Kapsel- oder Kartuschen-Cannabinoidgehalt basierend auf Laboranalyse berechnen.',
            concentrateVolume: 'Konzentrat Vol.*',
            fillerVolume: 'Füllvolumen',
            containerVolume: 'Kapsel/Kartusche Vol.',
            extractTestResults: 'Extrakt-Testergebnisse',
            THC: 'THC',
            THCa: 'THCa',
            delta8THC: 'Δ-8 THC',
            CBD: 'CBD',
            CBN: 'CBN',
            CBG: 'CBG',
            capCartTHC: 'Kap./Kart. THC*',
            capCartTHCa: 'Kap./Kart. THCa*',
            capCartDelta8THC: 'Kap./Kart. Δ-8 THC*',
            capCartCBD: 'Kap./Kart. CBD*',
            capCartCBN: 'Kap./Kart. CBN*',
            capCartCBG: 'Kap./Kart. CBG*',
            capCartTotalCannabinoids: 'Kap./Kart. Cannabinoide*',
            capsCartsMade: 'Kapseln/Kartuschen hergestellt',
            CapsuleCalcApproximateConversionNote: '*1 mL ≈ 1 g für Wasser, kann als ungefähre Umrechnung verwendet werden, wenn exaktes Volumen nicht bekannt ist. Wenn nach Gewicht gefüllt wird, kann mL überall dort, wo die Einheit erscheint, als mg gelesen werden.',
        
            decarboxylationCalculationDescription: 'Dies bestimmt die ungefähre Zeit zur vollständigen Decarboxylierung von trockenem Cannabis-Material basierend auf Daten aus wissenschaftlichen Quellen (mehr Infos im Gleichungsblock). Diese Zahlen sind eine Schätzung und können je nach Potenz, Dichte und Hydratation der Pflanze variieren. Keine Daten für Temperaturen unter 100°C verfügbar; Ergebnisse sind unter diesem Punkt unzuverlässig.',
            decarbTimeLabel: '~100% Decarb Zeit',
        
            decarbCurveEquations: [
                "Leistungskurve am besten angepasst, bestimmt aus den Datenpunkten folgender Quellen (identifiziert durch DOI und Autor):",
                "10.1016/j.forsciint.2015.07.019 (Taschwer et al.)",
                "   180min bei 100°C",
                "   60min bei 150°C",
                "10.1055/s-0031-1298334 (Eichler et al.)",
                "   12min bei 140°C",
                "   5min bei 210°C",
                "US7344736B2 (Patent)",
                "   240min bei 105°C",
                "   120min bei 120°C",
                "   60min bei 140°C",
                "",
                "Leistungskurve am besten angepasst: Zeit [Minuten] = 4e+12 * (Temperatur [°C])^-5.117",
            ],

            decarboxylationDescription: 'Berechnen Sie den Cannabinoidgehalt von Kapseln oder Kartuschen basierend auf Laboranalysen.',
            thcaLossTitle: 'Nur THCa-Verlust',
            thcaLossDescription: 'Bei der Decarboxylierung von Cannabis ist die wichtigste Reaktion die Umwandlung von Tetrahydrocannabinolsäure (THCa) in Tetrahydrocannabinol (THC), die tatsächliche psychoaktive Chemikalie. Durch die Decarboxylierung kommt es zum Verlust von Kohlendioxid, was zu einem Rückgang der molekularen Masse führt (358,4733 g/mol - 314,45 g/mol = 44,0233 g/mol Verlust (~12,22% Verlust)). Dieser Rechner ermöglicht es Ihnen, den verbleibenden THC-Gehalt nach der Decarboxylierung basierend auf den vor der Decarboxylierung vorhandenen THCa-Werten zu ermitteln. Beachten Sie, dass er den Masseverlust aufgrund der Umwandlung von CBDA in CBD, CBGA in CBG usw. nicht berücksichtigt, da diese Werte für Blumenproben in der Regel weniger genau bekannt sind.',
            productTHCaContent: 'THCa-Gehalt des Produkts',
            postDecarbTHCContent: 'THC-Gehalt nach der Decarboxylierung',
            productBasedLossTitle: 'Verlust basierend auf dem Produkt',
            productAmount: 'Produktmenge',
            productTHCaPercentage: 'THCa-Prozentsatz des Produkts',
            preDecarbTHC: 'THC vor der Decarboxylierung',
            postDecarbTHC: 'THC nach der Decarboxylierung',
            milligrams: 'mg',
            mgPerGram: 'mg/g',
            decarbLossEquations: [
                "THC-Gehalt nach der Decarboxylierung = THCa-Gehalt des Produkts * (314,45 / 358,4733)" 
            ],

            mgPerServingTitle: 'mg pro Portion',
            mgPerServingDescription: 'Bestimmen Sie die Potenz pro Portion unter Verwendung von Produkt/Potenz unter der Annahme einer 100%igen THC-Extraktion.',
            productPotency: 'Produktpotenz',
            servings: 'Portionen',
            decarbCorrectionLabel: 'Korrektur für Decarboxylierungsverluste',
            mgTHCPerServing: 'mg THC/Portion',
            percentTHC: '% THC',
            EdiblePotencyEquations: [
                "mg THC/Portion = (Produktmenge * Produktpotenz) / Portionen"
            ],

            productAmountTitle: 'Produktmenge',
            productAmountDescription: 'Ermitteln Sie die benötigte Produktmenge für eine gegebene Potenz unter der Annahme einer 100%igen THC-Extraktion.',
            productNeeded: 'Benötigte Produktmenge',
            edibleProductEquations: [
                "THC-Bedarf = Portionen * mg pro Portion",
                "Benötigte Produktmenge = THC-Bedarf / Produktpotenz",
            ],

            servingCountTitle: 'Anzahl der Portionen',
            servingCountDescription: 'Ermitteln Sie die Anzahl der Portionen für eine gewünschte Portionenpotenz und Produktmenge/Potenz unter der Annahme einer 100%igen THC-Extraktion.',
            servingsOutput: 'Portionen',
            edibleServingEquations: [
                "Portionen = (Produktmenge * Potenz) / mg THC pro Portion"
            ],

            solventEvaporationCalculatorDescription: 'Um diesen Rechner zu verwenden, messen Sie das Gewicht des von Ihnen verwendeten Lösungsmittels, bevor Sie es mit Cannabis in Kontakt bringen. Wiegen Sie es nach einer bestimmten Zeit erneut und notieren Sie das neue Gewicht. Schätzen Sie den groben Ertrag des Produkts, den Sie erwarten, als Korrekturfaktor (oder messen Sie das Gewicht des Lösungsmittels vor und nach dem Kontakt mit Cannabis für einen genaueren Wert), und dieser Rechner wird (unter der Annahme einer linearen Verdampfungsrate) die grobe Zeitdauer vorhersagen, die benötigt wird, bis das verbleibende Lösungsmittel verdampft ist. Beachten Sie bitte, dass dies sehr ungenau ist und nur für grobe Schätzungen verwendet werden sollte; die wahre Verdampfung des Lösungsmittels ist nicht immer linear.',
            preCannabisSolventWeight: 'Gewicht des Lösungsmittels vor Cannabis',
            currentSolventWeight: 'Aktuelles Gewicht des Lösungsmittels',
            timeSinceStart: 'Zeit seit Beginn',
            estimatedYield: 'Geschätzter Ertrag',
            evaporatedSolvent: 'Verdampftes Lösungsmittel',
            solventLossPerHour: 'Lösungsmittelverlust pro Stunde',
            timeToTotalEvaporation: 'Zeit bis zur vollständigen Verdampfung',

            evapPredictionEquations: [
                "[Korrigiertes aktuelles Gewicht des Lösungsmittels = Aktuelles Gewicht des Lösungsmittels - Geschätzter Ertrag]",
                "Verdampftes Lösungsmittel = Gewicht des Lösungsmittels vor Cannabis - Korrigiertes aktuelles Gewicht des Lösungsmittels",
                "Lösungsmittelverlust pro Stunde = Verdampftes Lösungsmittel / Zeit seit Beginn",
                "Zeit bis zur vollständigen Verdampfung = Korrigiertes aktuelles Gewicht des Lösungsmittels / Lösungsmittelverlust pro Stunde"
            ],

            extractionEfficiencyDescription: 'Bei der Herstellung von Extrakten ist die Effizienz des Verfahrens (wie viel Extrakt pro Einheit Ausgangsmaterial produziert wird) wichtig, wird aber weitgehend von der Extraktionseffizienz überschattet - wie viel des in der Ausgangsmasse vorhandenen THC im Extrakt landet. Zum Beispiel kann ein Verfahren weniger Extrakt produzieren, aber eine höhere THC-Konzentration aufweisen als ein anderes Verfahren, da es mehr THC und weniger Abfall (Chlorophyll usw.) aus der Pflanze extrahiert. Die Extraktionseffizienz bestimmt den Prozentsatz des extrahierten THC und liefert eine zuverlässigere Kennzahl zur Bewertung von Extraktionsprozessen.',
            feedstockWeight: 'Gewicht des Ausgangsmaterials',
            feedstockTHCContent: 'THC-Gehalt des Ausgangsmaterials',
            extractWeight: 'Gewicht des Extrakts',
            extractTHCContent: 'THC-Gehalt des Extrakts',
            weightYield: 'Gewichtsausbeute',
            totalFeedstockTHC: 'Gesamtes THC des Ausgangsmaterials',
            totalExtractTHC: 'Gesamtes THC des Extrakts',
            extractionEfficiency: 'Extraktionseffizienz',
            extractionEfficiencyEquations: [
                "Gewichtsausbeute = Gewicht des Extrakts / Gewicht des Ausgangsmaterials",
                "Gesamtes THC des Ausgangsmaterials = THC-Gehalt des Ausgangsmaterials * Gewicht des Ausgangsmaterials",
                "Gesamtes THC des Extrakts = THC-Gehalt des Extrakts * Gewicht des Extrakts",
                "Extraktionseffizienz = Gesamtes THC des Extrakts / Gesamtes THC des Ausgangsmaterials",
            ],

            oilButterPotencyTitle: 'Potenz von Öl/Butter',
            oilButterPotencyDescription: 'Ermitteln Sie die Potenz von Öl oder Butter, die speziell für ein Rezept zubereitet wurde, unter der Annahme einer 100%igen THC-Extraktion.',
            oilButterInfused: 'Infundiertes Öl/Butter',
            oilButterTotalTHC: 'Gesamtes THC von Öl/Butter',
            oilButterTHCPerTablespoon: 'THC pro Esslöffel Öl/Butter',
            oilButterTHCPerTeaspoon: 'THC pro Teelöffel Öl/Butter',
            mgPerTablespoon: 'mg/Esslöffel',
            mgPerTeaspoon: 'mg/Teelöffel',

            oilButterPotencyEquations: [
                "Gesamtes THC von Öl = Produktmenge * Potenz",
                "THC pro Menge = Gesamtes THC von Öl / Infundiertes Öl",
            ],

            partialOilButterBlendTitle: 'Teilweise Öl/Butter-Mischung',
            partialOilButterBlendDescription: 'Ermitteln Sie die Mischung aus medizinischer Butter/Öl mit normaler Butter/Öl für Rezepte mit einer bekannten gewünschten Dosierung, bei denen die ausschließliche Verwendung von medizinischer Butter/Öl zu einer zu potenten Dosierung führen würde.',
            medicatedOilPotency: 'Potenz von medizinischem Öl',
            recipeOilCalledFor: 'Von Rezept gefordertes Öl',
            desiredServings: 'Gewünschte Portionen',
            desiredPotency: 'Gewünschte Potenz',
            medicatedOilAmount: 'Menge des medizinischen Öls',
            regularOilAmount: 'Menge des regulären Öls',
            mgTHCPerTablespoon: 'mg THC/EL',
            tablespoons: 'EL',
            mgPerServing: 'mg/Portion',

            partialOilButterEquations: [
                "Menge des medizinischen Öls = Portionenanzahl * THC pro Portion / Potenz des medizinischen Öls",
                "Reguläres Öl = Gesamte benötigte Menge Öl - Menge des medizinischen Öls",
            ],

            additiveAmountCalculationDescription: 'Dies berechnet die Menge eines Zusatzstoffs in Fällen, in denen der Zusatzstoff maximal einen bestimmten Prozentsatz des endgültigen Bestandteils sein kann (z. B. empfehlen viele Terpenzusätze, dass der Anteil im Gemisch nicht mehr als 5 % betragen sollte; bei 200 g Konzentrat können Sie daher maximal 10,526 g Terpene hinzufügen).',
            startAmount: 'Startmenge',
            finalPercentageOfAdditive: 'Endprozentsatz des Zusatzstoffs',
            additiveAmountOutput: 'Zusatzstoffmenge',
            totalAmountOutput: 'Gesamtmenge',

            percentConstituentEquations: [
                "Gesamtmenge = Startmenge / (100 - Endprozentsatz des Zusatzstoffs)",
                "Zusatzstoffmenge = Gesamtmenge - Startmenge"
            ],

            knownIngredientsTitle: 'Bekannte Zutaten',
            knownIngredientsDescription: 'Ermitteln Sie die Menge und Potenz eines Endprodukts unter Verwendung bekannter Eingaben.',
            product1: 'Produkt 1',
            product2: 'Produkt 2',
            product3: 'Produkt 3',
            product4: 'Produkt 4',
            thc: 'THC',
            cbd: 'CBD',
            finalProduct: 'Endprodukt',
            totalTHC: 'Gesamtes THC',
            totalCBD: 'Gesamtes CBD',
            thcToCbdRatio: 'Verhältnis: 1THC zu',
            percentCBD: '% CBD',
            cbdUnit: 'CBD',

            saladGeneratorTitle: 'Salatgenerator',
            saladGeneratorDescription: 'Ermitteln Sie die Mischung von Optionen, die dem gewünschten Verhältnis am nächsten kommt.',
            oneTHCTo: '1 THC zu',
            maxElements: 'Maximale Elemente',
            minimumTHC: 'Mindest-THC',
            productLabel: 'Produkt',
            thcPercentage: '% THC',
            cbdPercentage: '% CBD',
            grams: 'g',
            cantMakeBlend: "Kann diese Mischung nicht herstellen!",

            thcPotencycalculatorSectionDescription: 'Wählen Sie den entsprechenden Abschnitt des Rechners für Ihre Einheiten aus. mg und g werden als Standardanalyseeinheiten verwendet. Wenn Ihre Ausgangswerte in einer anderen Einheit vorliegen, verwenden Sie unseren Weight Conversion-Rechner.',
            percentageTHC: 'Prozent THC',
            mgTHCPerGram: 'mg THC pro Gramm',
            mgTHCPerGramInput: 'mg THC/Gramm',
            percentageTHCOutput: 'Prozent THC',
            productVolume: 'Produktvolumen',
            productDensity: 'Produktdichte',
            mgMLTHC: 'mg/mL THC',
            mgGTHC: 'mg/g THC',
            thcPercentageOutput: 'THC-Prozentsatz',
            productWeight: 'Produktgewicht',
            mgTHCPerGramOutput: 'mg THC pro Gramm',
            milliliters: 'ml',
            gramsPerMilliliter: 'g/ml',

            variableServingPotencyTitle: 'Komplettes Rezept (Blüten, Volumen)',
            variableServingPotencyDescription: 'Ermitteln Sie die Aufteilung von Portionen und Potenz für ein Öl oder eine Butter, das/die speziell für ein Rezept zubereitet wurde, unter der Annahme einer 100%igen THC-Extraktion.',
            bakedGoodOilAmount: 'Menge Öl für Gebäck',
            bakedGoodServings: 'Portionen Gebäck',
            bakedGoodTotalTHC: 'Gesamtes THC im Gebäck',
            thcPerServing: 'THC/Portion',
            variableServingPotencyVolumeNote: '*Dieser Prozentsatz bezieht sich auf die Menge an trockenem Pflanzenmaterial im Vergleich zu nassem Material - z. B. 30 g trocken aus 100 g nassem Material würden einen 70%igen Trocknungsverlust bedeuten. Verwenden Sie unseren Percentage Change-Rechner, um die erwarteten trockenen und nassen Werte einzugeben, um zu dieser Zahl zu gelangen.',
            variableServingPotencyVolumeEquations: [
                "Gesamtes THC im Öl = Menge des Produkts * Potenz",
                "THC pro EL = Gesamtes THC im Öl / Infundierte Ölmenge",
                "Gesamtes THC im Gebäck = THC pro EL * Menge Öl für Gebäck (in EL)",
                "THC pro Portion = Gesamtes THC im Gebäck / Portionen",
            ],

            completeRecipeOilButterVolumeTitle: 'Komplettes Rezept (Öl/Butter, Volumen)',
            completeRecipeOilButterVolumeDescription: 'Ermitteln Sie die Aufteilung von Portionen und Potenz für ein Essbares, das mit bekanntem medizinischem Öl/Butter hergestellt wurde.',
            oilButterPotency: 'Potenz von Öl/Butter',
            mgPerCup: 'mg/Tasse',
            variableServPotenVolumeButteEquations: [
                "Gesamtes THC im Gebäck = THC pro EL * Menge Öl für Gebäck",
                "THC pro Portion = Gesamtes THC im Gebäck / Portionen",
            ],

            completeRecipeFlowersWeightTitle: 'Komplettes Rezept (Blüten, Gewicht)',
            completeRecipeFlowersWeightDescription: 'Ermitteln Sie die Aufteilung von Portionen und Potenz für ein Öl oder eine Butter, das/die speziell für ein Rezept zubereitet wurde, unter der Annahme einer 100%igen THC-Extraktion.',
            
            oilButterInfusedWeight: 'Infundierte Öl/Butter',
            bakedGoodOilAmountWeight: 'Menge Öl für Gebäck',
            oilButterTHCPerGram: 'THC pro Gramm Öl/Butter',
            variableServPotencyWeightEquations: [
                "Gesamtes THC im Gebäck = THC pro Gramm * Menge Öl für Gebäck",
                "THC pro Portion = Gesamtes THC im Gebäck / Portionen"
            ]






        },
        
    } //end of message
  
});

export default i18n;


